import React, { Component } from "react";
import "../public/assets/vendor/fonts/flag-icons.css";
import "../public/assets/vendor/fonts/fontawesome.css";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";
import VisibilityIcon from "@mui/icons-material/Visibility";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import FileViewer from "react-file-viewer";
import subDays from "date-fns/subDays";
import DateFnsUtils from "@date-io/date-fns";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import InputAdornment from "@material-ui/core/InputAdornment";
import { createTheme } from "@material-ui/core";
import { MuiPickersUtilsProvider, DatePicker } from "@material-ui/pickers";
import { ThemeProvider } from "@material-ui/styles";
import { Tab, TabList, TabPanel, Tabs } from "react-tabs";
import {
  FaCcVisa,
  FaCcMastercard,
  FaCcAmex,
  FaCcDiscover,
} from "react-icons/fa";
import { MdCreditCard } from "react-icons/md";
import ClearIcon from "@mui/icons-material/Clear";
import Checkbox from "@material-ui/core/Checkbox";
import Autocomplete from "@mui/material/Autocomplete";
import TextField from "@mui/material/TextField";
import Button from "@mui/material/Button";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import Dialog from "@material-ui/core/Dialog";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import debounce from "lodash.debounce";
import "react-datepicker/dist/react-datepicker.css";
import { ValidatorForm } from "react-material-ui-form-validator";
import "react-tabs/style/react-tabs.css";
import FetchServerData from "../../../provider/FetchServerData";
import {
  ActiveForBusinessType_Url,
  BusinessTypeList_Url,
  CheckExistingEmail_Url,
  GetCountryList_Url,
  Registration_Url,
  Static_Url,
  UploadTaxExcDoc_Url,
  StaticEventText_Url,
  GetTokenData_Url,
} from "../../../provider/ServiceUrl";
import Utils from "../../../provider/Utils";
import staticDataAction from "../../../redux/staticData/staticDataAction";
import store from "../../../redux/store";
import { withRouter } from "../../../withRouter";
import Footer from "../../website/home/Footer";
import CrmIntegration from "../../../assets/img/CrmIntegration.png";
import NeonCrmLogo from "../../../assets/img/Neon-CRM-Logo.png";
import BlackbaudLogo from "../../../assets/img/blackbaud_Logo.jpg";
import CventLogo from "../../../assets/img/cvent_Logo.jpeg";
import InfoTooltip from "../infoTooltip/InfoTooltip";
import PasswordRequirementsTooltip from "../passwordRequirementsTooltip/passwordRequirementsTooltip";
import PtsAlert from "../ptsAlert/PtsAlert";
import Multiselect from "multiselect-react-dropdown";
import "../public/assets/css/demo.css";
import "../public/assets/vendor/css/rtl/theme-default.css";
import "../public/assets/vendor/libs/bootstrap-select/bootstrap-select.css";
import "../public/assets/vendor/libs/bs-stepper/bs-stepper.css";
import "../public/assets/vendor/libs/formvalidation/dist/css/formValidation.min.css";
import "../public/assets/vendor/libs/perfect-scrollbar/perfect-scrollbar.css";
import "../public/assets/vendor/libs/select2/select2.css";
import "../public/assets/vendor/libs/typeahead-js/typeahead.css";
import "./Registration.css";
import Header from "../../website/home/Header";
import { BUSINESS_DOMAIN, SUBSCRIPTION_TYPES } from "../../../provider/Enums";
import { DialogActions } from "@material-ui/core";
import RegCreditCardForm from "./RegCreditCardForm";
import { Elements, ElementsConsumer } from "@stripe/react-stripe-js";
import { loadStripe } from "@stripe/stripe-js";
import pdfFile from "../../../assets/importTemplate/GivBee_Cvent_Setup.pdf";
import ChoosePlanIcon from "../../../assets/img/planning.png"
import EventIcon from "../../../assets/img/event.png"
import WorkPlaceIcon from "../../../assets/img/workplace.png"
import UserIcon from "../../../assets/img/user.png"
import IntegrationIcon from "../../../assets/img/integration.png"
import BillingIcon from "../../../assets/img/credit-card.png"
const stripePromise = loadStripe(
  process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY
);

const materialTheme = createTheme({
  overrides: {
    MuiPickersToolbar: {
      toolbar: {
        backgroundColor: "#008181",
      },
    },
    MuiPickersCalendarHeader: {
      switchHeader: {
        backgroundColor: "white",
        color: "#005476",
      },
    },
  },
});
class Registration extends Component {
  countryListArray = [];
  stateListArray = [];
  constructor(props) {
    super(props);
    const str = new URLSearchParams(window.location.search);
    const token = str.get("token");
    if (token) {
      this.getTokenData(token);
    } else {
      this.getBussinessTypeList();
    }

    this.state = {
      userName: "",
      password: "",
      firstName: "",
      lastName: "",
      jobTitle: "",
      phone: "",
      phoneNumber: "",
      countryCode: "",
      officeCountryCode: "",
      officePhone: "",
      officePhoneNumber: "",
      showConfirmPassword: false,
      confirmPassword: "",
      campaignDescription: "",
      keyword: "",
      sampleText1: "",
      sampleText2: "",
      optInPermissionMethod: "",
      textPerMonth: "",
      businessName: "",
      selectedTaxDocFile: { name: "" },
      error: {
        one: true,
        two: true,
        three: true,
        four: true,
        five: true,
      },
      userAutoFocus: false,
      passwordFocussed: false,
      passwordHelperText: "",
      cwUrlErrorMessage: "",
      tcUrlErrorMessage: "",
      ppUrlErrorMessage: "",
      einErrorMessageText: "",
      confirmPasswordHelperText: "",
      activeAccountDetailsStep: false,
      activeEventDetailsStep: false,
      activeCompanyDetailsStep: false,
      activeGivBeePlanStep: true,
      activeCustomPlanStep: false,
      activeBillingLinksStep: false,
      activeIntegrationStep: false,
      fundraisingTab: true,
      restaurantsAndFoodTruckTab: false,
      businessIndustryList: [],
      businessIndustry: null,
      sendMessageTypeList: [],
      sendMessageType: "",
      orgBusinessTypeList: [],
      orgBusinessType: null,
      businessType: null,
      businessUseCaseList: [],
      businessTypeList: [],
      selectedTabColor: "#eac891",
      planList: [],
      tabPlanList: [],
      messageType: "",
      messageTypeList: [],
      sendTextCanada: "",
      showPassword: false,
      optinCollectionOptionList: [],
      organizationTypeList: [],
      optinPermissonMethodList: [],
      textingCountryList: [],
      selectedTab: 0,
      cardType: "",
      cardNumber: "",
      cardOwnerName: "",
      cardFirstName: "",
      cardLastName: "",
      cardMonth: "",
      cvvCode: "",
      cardYear: "",
      isExpiryDate: false,
      payPal: "",
      selectedPlanId: "",
      acceptTermsConditionCheckbox: false,
      smsConsentPrivacyCheckbox: false,
      selectedPlanCheckbox: false,
      selectedId: null,
      printerList: [],
      isChecked: true,
      defaultPrinter: {},
      checked: {},
      selectedPlan: {},
      businessUseCase: null,
      registration: {},
      line: "",
      state: null,
      city: "",
      zipcode: "",
      billingLine: "",
      billingCountry: null,
      billingState: null,
      billingCity: "",
      billingZipcodes: "",
      eInNumber: "",
      timeZone: null,
      showTitle: false,
      showTaxExemptQue: false,
      uploadFileShow: false,
      crmIntegrationList: [],
      crmIntegration: null,
      eventTypes: [],
      cventDataCarryoverTypes: [],
      startDate: null,
      endDate: null,
      eventName: "",
      eventPlanId: "",
      eventCountry: this.defaultCountry,
      eventState: null,
      eventTimeZone: null,
      eventType: null,
      ceventCarryover: null,
      ceventCode: "",
      isConnectToCvent: false,
      eventRegConfirmationText: "",
      neonOrgApiKeyShow: false,
      blackBaudRefreshShow: false,
      CEventShow: false,
      errorMassage: false,
      eventError: false,
      neonOrgId: "",
      neonOrgApiKey: "",
      zipCodeErrorMessageText: "",
      blackBaudRefreshToken: "",
      blackBaudAccessToken: "",
      selectedPlanListItem: {},
      payPalIdShow: false,
      paymentServicesType: null,
      paymentServiceTypeList: [],
      taxExemptNo: false,
      taxExYes: false,
      isUseCases: false,
      smsTAndCUrl: "",
      smsPrivacyPolicyUrl: "",
      npoTaxDocumentId: "",
      companyWebsite: "",
      openBlackbaud: false,
      isTextingCountries: false,
      isScheduleCall: false,
      isbillingorgsame: false,
      otherCountryShow: false,
      otherCountryList: [],
      otherCountry: null,
      showFile: false,
      showFileView: false,
      isTaxDocDragging: false,
      eventDateErrorMassage: false,
      companyStepClickable: false,
      accountStepClickable: false,
      eventStepClickable: false,
      integrationStepClickable: false,
      billingStepClick: false,
    };
  }

  getTokenData(token) {
    const postObject = {
      token: token,
    };
    FetchServerData.callPostService(GetTokenData_Url, postObject).then(
      (output) => {
        if (output.status === "SUCCESS") {
          const paramters = output.data?.paramters;
          const email = paramters?.email;
          const planId = paramters?.planId;
          if (undefined !== planId && planId > 0) {
            this.getPlanDetails(planId);
          }
          this.setState({
            email: email !== "undefined" ? email : "",
            planId: planId,
          });
        }
      }
    );
  }

  getBussinessTypeList() {
    // make API call
    const postObject = {};
    FetchServerData.callPostService(BusinessTypeList_Url, postObject)
      .then((response) => {
        let output = response;
        if (output.status === "SUCCESS") {
          let businessTypeList = output.data.businessTypeList;
          this.handleBusinessTypeChange(businessTypeList[0]);
          this.setState({
            activeCustomPlanStep: false,
            businessTypeList: businessTypeList,
            businessType: businessTypeList[0],
          });
        } else {
        }
      })
      .catch((error) => { });
  }

  getPlanDetails(planId) {
    const postObject = {
      header: {},
      plan: { id: planId },
    };
    FetchServerData.callPostService("/planms/get", postObject)
      .then((response) => {
        if (response.status === "SUCCESS") {
          let planDetails = response.data?.plan;
          // let businessUseCaseDetails = response.data?.plan?.businessUseCase;
          // let businessTypeList = [];
          // let businessUseCaseList = [];
          let planList = [];
          let tabPlanList = [];
          // businessTypeList.push(businessUseCaseDetails?.businessType);
          // businessUseCaseList.push(businessUseCaseDetails);
          planList.push(planDetails);
          tabPlanList.push(planDetails?.planType);

          // businessUseCaseList.map((item, index) => {
          //   if (index === 0) {
          //     item.isChecked = true;
          //     return item;
          //   }
          // });
          let smsConsentPrivacyCheckbox = ["CustomMonthly", "CustomYearly", "CustomOnetime"]?.includes(planDetails?.planType?.type);
          this.getStaticData(planDetails?.businessDomainName);
          this.setState({
            activeCustomPlanStep: true,
            planList: planList,
            tabPlanList: tabPlanList,
            smsConsentPrivacyCheckbox: smsConsentPrivacyCheckbox,
            // businessTypeList: businessTypeList,
            // businessUseCaseList: businessUseCaseList,
            // businessType: businessTypeList[0],
          });
        } else {
        }
      })
      .catch((error) => { });
  }
  getStaticData(businessDomainName) {
    let StaticUrl = Utils.equalsIgnoreCase(
      businessDomainName,
      BUSINESS_DOMAIN.eventText
    )
      ? StaticEventText_Url
      : Static_Url;
    const postObject = {
      header: {},
      businessDomain: businessDomainName,
    };
    FetchServerData.callPostService(StaticUrl, postObject)
      .then((response) => {
        let output = response;
        if (output.status === "SUCCESS") {
          let staticData = output.data;
          this.countryListArray = staticData.countryList;
          store.dispatch(staticDataAction.setStaticData(output.data));
          for (let i = 0; i < staticData.businessIndustryList.length; i++) {
            if (
              staticData.businessIndustryList[i].industry === "Non For Profit"
            ) {
              this.setState({
                businessIndustry: staticData.businessIndustryList[i],
              });
            }
          }
          this.setState({
            businessIndustryList: staticData.businessIndustryList,
            orgBusinessTypeList: staticData.businessTypeList,
            messageTypeList: staticData.messageTypeList,
            sendMessageTypeList: staticData.sendMessageTypeList,
            optinCollectionOptionList: staticData.optinCollectionOptionList,
            organizationTypeList: staticData.organizationTypeList,
            optinPermissonMethodList: staticData.optinPermissonMethodList,
            country: staticData.defaultCountry,
            billingCountry: staticData.defaultCountry,
            crmIntegrationList: staticData.crmIntegrationList,
            paymentServiceTypeList: staticData.paymentServiceTypeList,
            paymentServicesType: staticData.paymentServiceTypeList[0],
            cventDataCarryoverTypes: staticData.cventDataCarryoverTypes,
            eventTypes: staticData.eventTypes,
            crmIntegration:
              staticData.crmIntegrationList[
              staticData.crmIntegrationList.findIndex(
                (i) => i.name.toLowerCase() === "None".toLowerCase()
              )
              ],
          });
          this.handleCountryChange(staticData.defaultCountry);
          // this.handleEventCountryChange(staticData.defaultCountry);
        } else {
        }
      })
      .catch((error) => { });
  }
  handleUserNameChange(e) {
    this.setState({ userName: e.target.value });
  }

  handleFirstNameChange(e) {
    this.setState({ firstName: e.target.value });
  }
  handleLastNameChange(e) {
    this.setState({ lastName: e.target.value });
  }

  handleEmailChange(e) {
    this.setState({ email: e.target.value });
  }
  handleJobTitleChange(e) {
    this.setState({ jobTitle: e.target.value });
  }

  handlePhoneChange(e) {
    let val = e.target.value;
    const prevVal = this.state.phone || "";
    const isDeleting = val.length < prevVal.length;
    let value = isDeleting ? val : Utils.phoneNumberFormate(val);
    this.setState({
      phone: value,
      phoneNumber: value.replace(/-/g, ""),
      mobilephoneHelperText:
        value.length === 12 ? "" : this.state.mobilephoneHelperText,
    });
  }

  handleOfficePhoneChange(e) {
    let val = e.target.value;
    const prevVal = this.state.officePhone || "";
    const isDeleting = val.length < prevVal.length;
    let value = isDeleting ? val : Utils.phoneNumberFormate(val);

    this.setState({
      officePhone: value,
      officePhoneNumber: value.replace(/-/g, ""),
      officephoneHelperText:
        value.length === 12 ? "" : this.state.officephoneHelperText,
    });
  }

  handleCountryCodeChange(phone, country, e, formattedValue) {
    this.setState({
      countryCode: formattedValue,
    });
  }
  handleOfficeCountryChange(phone, country, e, formattedValue) {
    this.setState({
      officeCountryCode: formattedValue,
    });
  }

  handleCampaignDescriptionChange(e) {
    this.setState({ campaignDescription: e.target.value });
  }
  handleClickShowConfirmPassword() {
    this.setState({ showConfirmPassword: !this.state.showConfirmPassword });
  }
  toggleFocusNewPassword = () => {
    this.setState((prevState) => {
      return { passwordFocussed: !prevState.passwordFocussed };
    });
  };

  handlePasswordChange = (e) => {
    const { name, value } = e.target;
    this.setState({ [name]: value });
    if (name === "password") {
      this.debouncedValidatePassword(value);
    } else if (name === "confirmPassword") {
      this.debouncedValidatePassword(this.state.password);
    }
  };
  handleClickShowPassword() {
    this.setState({ showPassword: !this.state.showPassword });
  }

  debouncedValidatePassword = debounce(
    (password) => this.validatePassword(password),
    1000
  );

  validatePassword = (password) => {
    let one = false,
      two = false,
      three = false,
      four = false,
      five = false;

    if (password.length < 12) {
      one = true;
    }
    if (!password.match(/[A-Z]/)) {
      two = true;
    }
    if (!password.match(/[a-z]/)) {
      three = true;
    }
    if (!password.match(/[\d]/)) {
      four = true;
    }
    if (!password.match(/[\W]/)) {
      five = true;
    }

    if (one || two || three || four || five) {
      this.setState({
        error: { one, two, three, four, five },
        passwordHelperText: "Password requirements not met",
        confirmPasswordHelperText: "",
      });
      return false;
    }

    // if (password !== confirmPassword) {
    //   this.setState({
    //     disable: true,
    //     passwordHelperText: "",
    //     confirmPasswordHelperText: "Passwords do not match",
    //   });
    //   return false;
    // }

    this.setState({
      disable: false,
      error: {},
      passwordHelperText: "",
      confirmPasswordHelperText: "", // match, so clear error
    });
    return true;
  };

  handleNextAccountDetailsPage(e) {
    e.preventDefault();
    window.scroll(0, 0);
    if (this.state.eInNumber.length < 10) {
      this.setState({
        einErrorMessageText: "Valid 9-digit EIN number required",
      });
    } else {
      this.setState({
        activeAccountDetailsStep: true,
        activeEventDetailsStep: false,
        activeCompanyDetailsStep: false,
        activeUseCaseDetailsStep: false,
        activeGivBeePlanStep: false,
        activeBillingLinksStep: false,
        userAutoFocus:
          this.state.email === "" || this.state.email === undefined
            ? true
            : false,
        accountStepClickable: true,
      });
    }
  }
  handlePreviousCompanyDetailsPage(e) {
    window.scroll(0, 0);
    this.setState({
      activeAccountDetailsStep: false,
      activeEventDetailsStep: false,
      activeCompanyDetailsStep: true,
      activeUseCaseDetailsStep: false,
      activeGivBeePlanStep: false,
      activeBillingLinksStep: false,
    });
  }

  handlePreviousUseCaseDetailsPage(e) {
    e.preventDefault();

    this.setState({
      activeAccountDetailsStep: true,
      activeEventDetailsStep: false,
      activeCompanyDetailsStep: false,
      activeGivBeePlanStep: false,
      activeBillingLinksStep: false,
      activeIntegrationStep: false,
    });
  }
  handlePreviousEventDetailsPage(e) {
    e.preventDefault();

    this.setState({
      activeAccountDetailsStep: true,
      activeEventDetailsStep: false,
      activeCompanyDetailsStep: false,
      activeGivBeePlanStep: false,
      activeBillingLinksStep: false,
      activeIntegrationStep: false,
    });
  }

  handlePreviousIntegrationDetailsPage(e) {
    e.preventDefault();
    window.scroll(0, 0);
    this.setState({
      activeAccountDetailsStep: false,
      activeEventDetailsStep: false,
      activeCompanyDetailsStep: false,
      activeGivBeePlanStep: false,
      activeBillingLinksStep: false,
      activeIntegrationStep: true,
    });
  }
  handlePreviousPlanDetailsPage(e) {
    e.preventDefault();

    this.setState({
      activeAccountDetailsStep: false,
      activeEventDetailsStep: false,
      activeCompanyDetailsStep: false,
      activeUseCaseDetailsStep: false,
      activeGivBeePlanStep: true,
      activeBillingLinksStep: false,
    });
  }
  handleNextUseCaseDetailsPage(e) {
    e.preventDefault();

    this.setState({
      activeAccountDetailsStep: false,
      activeEventDetailsStep: false,
      activeCompanyDetailsStep: false,
      activeUseCaseDetailsStep: true,
      activeGivBeePlanStep: false,
      activeBillingLinksStep: false,
    });
  }
  handleNextBillingDetailsPage(e) {
    e.preventDefault();
    window.scroll(0, 0);
    this.setState({
      activeAccountDetailsStep: false,
      activeEventDetailsStep: false,
      activeCompanyDetailsStep: false,
      activeUseCaseDetailsStep: false,
      activeGivBeePlanStep: false,
      activeBillingLinksStep: true,
      activeIntegrationStep: false,
    });
  }
  handleNextIntegrationDetailsPage(e) {
    e.preventDefault();
    window.scroll(0, 0);
    const isPasswordValid = this.validatePassword(this.state.password);
    if (!isPasswordValid) {
      this.setState({
        passwordFocussed: true,
      });
      return;
    } else {
      this.setState({
        passwordFocussed: false,
      });
    }
    if (this.state.password !== this.state.confirmPassword) {
      this.setState({
        confirmPasswordHelperText: "Passwords must match",
      });
      return;
    }

    if (this.state.phoneNumber.length !== 10) {
      this.setState({
        mobilephoneHelperText: "Phone number must be 10 digits",
      });
      return;
    } else if (this.state.officePhoneNumber.length !== 10) {
      this.setState({
        officephoneHelperText: "Phone number must be 10 digits",
      });
      return;
    }

    this.setState({
      activeAccountDetailsStep: false,
      activeEventDetailsStep: false,
      activeCompanyDetailsStep: false,
      activeUseCaseDetailsStep: false,
      activeGivBeePlanStep: false,
      activeBillingLinksStep: false,
      activeIntegrationStep: true,
      confirmPasswordHelperText: "",
      mobilephoneHelperText: "",
      officephoneHelperText: "",
      integrationStepClickable: true,
    });
  }
  handleNextEventDetailsPage(e) {
    e.preventDefault();
    window.scroll(0, 0);
    const isPasswordValid = this.validatePassword(this.state.password);
    if (!isPasswordValid) {
      this.setState({
        passwordFocussed: true,
      });
      return;
    } else {
      this.setState({
        passwordFocussed: false,
      });
    }
    if (this.state.password !== this.state.confirmPassword) {
      this.setState({
        confirmPasswordHelperText: "Passwords must match",
      });
      return;
    }

    if (this.state.phoneNumber.length !== 10) {
      this.setState({
        mobilephoneHelperText: "Phone number must be 10 digits",
      });
      return;
    } else if (this.state.officePhoneNumber.length !== 10) {
      this.setState({
        officephoneHelperText: "Phone number must be 10 digits",
      });
      return;
    }

    this.setState({
      activeAccountDetailsStep: false,
      activeEventDetailsStep: true,
      activeCompanyDetailsStep: false,
      activeUseCaseDetailsStep: false,
      activeGivBeePlanStep: false,
      activeBillingLinksStep: false,
      activeIntegrationStep: false,
      confirmPasswordHelperText: "",
      mobilephoneHelperText: "",
      officephoneHelperText: "",
      eventStepClickable: true,
    });
  }
  handleNextGiveBeePlanPage(e) {
    e.preventDefault();

    this.setState({
      activeAccountDetailsStep: false,
      activeEventDetailsStep: false,
      activeCompanyDetailsStep: false,
      activeUseCaseDetailsStep: false,
      activeGivBeePlanStep: false,
      activeBillingLinksStep: true,
    });
  }
  handleAddressChange(address) {
    this.setState({ address: address });
  }
  handleBillingAddressChange(billingAddress) {
    this.setState({ billingAddress: billingAddress });
  }
  handleClickCheckBox = (e) => {
    if (e.target.checked === "true") {
      this.setState({
        checkbox: e.target.checked,
        isDisabled: false,
      });
    } else {
      this.setState({
        checkbox: e.target.checked,
        isDisabled: true,
      });
    }
  };

  handleClickAcceptTermsConditionCheckBox = (e) => {
    const isChecked = e.target.checked;
    // const disabledButton = isChecked && this.state.smsConsentPrivacyCheckbox;
    this.setState({
      acceptTermsConditionCheckbox: isChecked,
      // isDisabled: disabledButton,
    });
  };

  handleClickSmsConsentPrivacyCheckBox = (e) => {
    const isChecked = e.target.checked;
    // const disabledButton = isChecked && this.state.acceptTermsConditionCheckbox;
    this.setState({
      smsConsentPrivacyCheckbox: isChecked,
      // isDisabled: disabledButton,
    });
  };

  // handleClickSelectedPlanCheckBox(e, data) {
  //   if (e.target.checked === "true") {
  //     this.setState({
  //       selectedPlanCheckbox: e.target.checked,
  //       isDisabled: false,
  //     });
  //   } else {
  //     this.setState({
  //       selectedPlanCheckbox: e.target.checked,
  //       isDisabled: true,
  //     });
  //   }
  // }

  handleChange(e, selectedUsecase) {
    let plan = selectedUsecase?.plans;
    plan.sort((a, b) => b.displaysequence - a.displaysequence);
    const value = e.target.value;
    const modifiedData = [...this.state.businessUseCaseList];
    modifiedData.map((item) => {
      item.isChecked = item.id === +value;
      return item;
    });

    let tabPlanList = selectedUsecase?.planTypes?.filter(plan => plan.type !== "LegacyOntime")
      .sort((a, b) => a.displaySequence - b.displaySequence);

    this.setState({
      planList: plan,
      tabPlanList: tabPlanList,
      businessUseCaseList: modifiedData,
      businessUseCase: selectedUsecase,
      showTitle: true,
    });
    // this.getPlanCategory(selectedPlan.id);
  }
  handleTaxExemptCheckedChange(e) {
    if (e.target.checked === true) {
      this.setState({
        taxExYes: e.target.checked,
        yesButUploadDocLater: false,
        taxExemptNo: false,
        uploadFileShow: true,
      });
    } else {
      this.setState({
        taxExYes: e.target.checked,
        yesButUploadDocLater: false,
        taxExemptNo: false,
        uploadFileShow: false,
      });
    }
  }

  handleNoTaxExemptCheckedChange(e) {
    this.setState({
      taxExemptNo: e.target.checked,
      taxExYes: false,
      yesButUploadDocLater: false,
      uploadFileShow: false,
    });
  }
  handleYesButLaterTaxExemptCheckedChange(e) {
    this.setState({
      yesButUploadDocLater: e.target.checked,
      taxExemptNo: false,
      taxExYes: false,
      uploadFileShow: false,
    });
  }
  setKey(tab) {
    this.setState({
      selectedTab: tab,
    });
  }
  handleOnClickSelectedPlan(selectedPlan, e) {
    // e.preventDefault();
    window.scroll(0, 0);
    if (this.state.businessType?.name === "Non-profit / Charity") {
      for (let i = 0; i < this.state.businessIndustryList.length; i++) {
        if (
          Utils.equalsIgnoreCase(
            this.state.businessIndustryList[i].industry,
            "Not For Profit"
          )
        ) {
          this.setState({
            businessIndustry: this.state.businessIndustryList[i],
            showTaxExemptQue: true,
          });
        }
      }
      for (let i = 0; i < this.state.organizationTypeList.length; i++) {
        if (
          Utils.equalsIgnoreCase(
            this.state.organizationTypeList[i].type,
            "Non-Profit"
          )
        ) {
          this.setState({
            companyType: this.state.organizationTypeList[i],
            showTaxExemptQue: true,
          });
        }
      }
      for (let i = 0; i < this.state.orgBusinessTypeList.length; i++) {
        if (
          Utils.equalsIgnoreCase(
            this.state.orgBusinessTypeList[i].type,
            "Non-Profit Corporation"
          )
        ) {
          this.setState({
            orgBusinessType: this.state.orgBusinessTypeList[i],
            showTaxExemptQue: true,
          });
        }
      }
    } else {
      this.setState({
        // businessIndustry: null,
        // companyType: null,
        // orgBusinessType: null,
        showTaxExemptQue: false,
      });
    }
    this.setState({
      selectedPlanId: selectedPlan.id,
      activeAccountDetailsStep: false,
      activeEventDetailsStep: false,
      activeCompanyDetailsStep: true,
      activeUseCaseDetailsStep: false,
      activeGivBeePlanStep: false,
      activeBillingLinksStep: false,
      selectedPlan: selectedPlan,
      companyStepClickable: true,
    });
  }

  handleOnClickSelectedTab(selectedPlan, e) {
    this.getPlanCategory(selectedPlan.id);
  }
  handleEinChange(e) {
    let val = e.target.value;
    let value = this.einNumberAutoFormat(val);
    let res = value.substring(0, 11);
    if (res.length < 11) {
      this.setState({
        eIn: value,
        einErrorMessageText: "",
        eInNumber: e.target.value,
      });
    }
  }

  einNumberAutoFormat(einNumber) {
    const number = einNumber.replace(/\D/g, "");
    const isCanada = Utils.equalsIgnoreCase(
      this.state.country?.name,
      "Canada"
    );

    if (isCanada) {
      const trimmed = number.substring(0, 9);
      if (trimmed.length > 5) {
        return trimmed.replace(/(\d{5})(\d{0,4})/, "$1 $2").trim();
      }

      return trimmed;
    } else {
      const trimmed = number.substring(0, 9);
      if (trimmed.length > 2) {
        return trimmed.replace(/(\d{2})(\d{0,7})/, "$1-$2");
      }

      return trimmed;
    }
  }

  handleCompanyTypeChange(selectedType) {
    const { orgBusinessTypeList, businessIndustryList } = this.state;
    const nonProfitOrgBusinessType = orgBusinessTypeList.find(
      (bt) => bt.type === "Non-Profit Corporation"
    );
    const nonProfitIndustry = businessIndustryList.find(
      (bi) => bi.industry === "Not for profit"
    );
    if (selectedType?.type === "Non-Profit") {
      this.setState({
        companyType: selectedType,
        orgBusinessType: nonProfitOrgBusinessType || null,
        businessIndustry: nonProfitIndustry || null,
        showTaxExemptQue: true,
      });
    } else {
      this.setState({
        companyType: selectedType,
        showTaxExemptQue: false,
      });
    }
    if (undefined !== this.state.onChange && null !== this.state.onChange) {
      this.state.onChange(this.state);
    }
  }
  handleCrmIntegrationChange(selectedType) {
    this.state.crmIntegration = selectedType;
    if (undefined === this.state.onChange) {
      this.setState({
        neonOrgApiKeyShow: false,
        blackBaudRefreshShow: false,
        CEventShow: false,
      });
    }
    if (undefined !== this.state.onChange && null !== this.state.onChange) {
      this.state.onChange(this.state);
    }

    if (Utils.equalsIgnoreCase(selectedType?.name, "NeonCRM")) {
      this.setState({
        crmIntegration: selectedType,
        neonOrgApiKeyShow: true,
        blackBaudRefreshShow: false,
        CEventShow: false,
      });
    } else if (Utils.equalsIgnoreCase(selectedType?.name, "BlackBaudCRM")) {
      this.setState({
        crmIntegration: selectedType,
        neonOrgApiKeyShow: false,
        blackBaudRefreshShow: true,
        CEventShow: false,
      });
    } else if (Utils.equalsIgnoreCase(selectedType?.name, "Cvent")) {
      this.setState({
        crmIntegration: selectedType,
        neonOrgApiKeyShow: false,
        blackBaudRefreshShow: false,
        CEventShow: true,
      });
    } else if (Utils.equalsIgnoreCase(selectedType?.name, "None")) {
      this.setState({
        crmIntegration: selectedType,
        neonOrgApiKeyShow: false,
        blackBaudRefreshShow: false,
        CEventShow: false,
      });
    }
  }
  handlePaymentServicesTypeChange(selectedType) {
    this.state.paymentServicesType = selectedType;
    if (undefined !== this.state.onChange && null !== this.state.onChange) {
      this.state.onChange(this.state);
    }

    if (Utils.equalsIgnoreCase(selectedType?.type, "PayPal")) {
      this.setState({
        paymentServicesType: selectedType,
        payPalIdShow: true,
      });
    } else {
      this.setState({
        paymentServicesType: selectedType,
        payPalIdShow: false,
      });
    }
  }
  handleBusinessNameChange(e) {
    this.setState({ businessName: e.target.value });
  }
  handleNeonOrgApiKeyChange(e) {
    this.setState({ neonOrgApiKey: e.target.value });
  }
  handleNenOrgIdChange(e) {
    this.setState({ neonOrgId: e.target.value });
  }
  handleBlackBaudAccessTokenChange(e) {
    this.setState({ blackBaudAccessToken: e.target.value });
  }
  handleBlackBaudRefreshTokenChange(e) {
    this.setState({ blackBaudRefreshToken: e.target.value });
  }

  handleSmsTAndCUrlChange(e) {
    const val = e.target.value;
    let tcUrlErrorMessage = "";
    // if (val !== "") {
    //   const valid = Utils.urlPattern(val);
    //   if (!valid) {
    //     tcUrlErrorMessage = "Please enter valid URL";
    //   }
    // }
    this.setState({
      smsTAndCUrl: val,
      tcUrlErrorMessage,
    });
  }
  handleSmsPrivacyPolicyUrlChange(e) {
    const val = e.target.value;
    let ppUrlErrorMessage = "";
    // if (val !== "") {
    //   const valid = Utils.urlPattern(val);
    //   if (!valid) {
    //     ppUrlErrorMessage = "Please enter valid URL";
    //   }
    // }
    this.setState({
      smsPrivacyPolicyUrl: val,
      ppUrlErrorMessage,
    });
  }
  handleCompanyWebsiteChange(e) {
    const val = e.target.value;
    let cwUrlErrorMessage = "";
    // if (val !== "") {
    //   const valid = Utils.urlPattern(val);
    //   if (!valid) {
    //     cwUrlErrorMessage = "Please enter valid URL";
    //   }
    // }
    this.setState({
      companyWebsite: val,
      cwUrlErrorMessage,
    });
  }
  handleBusinessAddressChange(e) {
    this.setState({ businessAddress: e.target.value });
  }

  // handleCardTypeChange(selectedType) {
  //   this.state.cardType = selectedType;
  //   this.setState({
  //     cardType: selectedType,
  //   });
  //   if (undefined !== this.state.onChange && null !== this.state.onChange) {
  //     this.state.onChange(this.state);
  //   }
  // }

  handleCardTypeChange(e) {
    const { value } = e.target;
    this.setState({ cardType: value });
  }

  handleCardNumberChange(e) {
    let number = Utils.formatCardNumber(e.target.value);
    this.setState({ cardNumber: number });
  }

  handleCardNameChange(e) {
    this.setState({ cardOwnerName: e.target.value });
  }

  handleCardFirstnameChange(e) {
    this.setState({ cardFirstName: e.target.value });
  }
  handleCardLastnameChange(e) {
    this.setState({ cardLastName: e.target.value });
  }

  handleExpiryDateChange(e) {
    let date = e.target.value?.replace(/[^0-9]/g, ""); // Remove non-numeric characters
    let month = "";
    let year = "";
    if (date.length > 6) date = date?.slice(0, 6); // Limit to 6 digits

    // Format as MM/YYYY
    if (date.length >= 3) {
      date = `${date.slice(0, 2)}/${date.slice(2)}`;
      month = date.slice(0, 2);
      year = date.slice(3);
    }
    const valid = Utils.isExpiryValid(date);
    this.setState({
      expiryDate: date,
      cardMonth: month,
      cardYear: year,
      isExpiryDate: !valid,
    });
  }

  handlePayPalChange(e) {
    this.setState({ payPal: e.target.value });
  }
  handleCardMonthChange(date) {
    this.setState({ cardMonth: date });
  }
  handleCardYearChange(date) {
    this.setState({ cardYear: date });
  }
  handleCvvCodeChange(e) {
    this.setState({ cvvCode: e.target.value });
  }

  handleBillingOrgSame(e) {
    if (e.target.checked) {
      this.setState({
        isbillingorgsame: e.target.checked,
        billingLine: this.state.line,
        billingCity: this.state.city,
        billingZipcode: this.state.zipcode,
        billingState: this.state.state,
        billingCountry: this.state.country,
      });
    } else {
      this.setState({
        isbillingorgsame: e.target.checked,
        billingLine: "",
        billingCity: "",
        billingZipcode: "",
        billingState: null,
        billingCountry: null,
      });
    }
  }

  handleBusinessIndustryChange(selectedIndustry) {
    this.state.businessIndustry = selectedIndustry;
    this.setState({
      businessIndustry: selectedIndustry,
    });
    if (undefined !== this.state.onChange && null !== this.state.onChange) {
      this.state.onChange(this.state);
    }
  }
  handleKeyWordChange(e) {
    const { value } = e.target;
    this.setState({ keyword: value });
  }
  handleSendMessageTypeChange(e) {
    const { value } = e.target;
    this.setState({ sendMessageType: value });
  }
  handleOptInPermissionMethodChange(e) {
    const { value } = e.target;
    this.setState({ optInPermissionMethod: value });
  }
  handleMessageTypeListChange(e) {
    const { value } = e.target;
    this.setState({ messageType: value });
  }
  handleTextPerMonthChange(e) {
    const { value } = e.target;
    this.setState({ textPerMonth: value });
  }
  handleSampleText1Change(e) {
    const { value } = e.target;
    this.setState({ sampleText1: value });
  }
  handleSampleText2Change(e) {
    const { value } = e.target;
    this.setState({ sampleText2: value });
  }
  handleSendTextCanadaChange(e) {
    const { value } = e.target;
    this.setState({ sendTextCanada: value });
  }
  handleOptInCollectionFromAudienceChange(e) {
    const { value } = e.target;
    this.setState({ optInCollectionFromAudience: value });
  }

  handleOrgBusinessTypeChange(selectedType) {
    this.state.orgBusinessType = selectedType;
    this.setState({
      orgBusinessType: selectedType,
    });
    if (undefined !== this.state.onChange && null !== this.state.onChange) {
      this.state.onChange(this.state);
    }
  }

  getBusinessUsecase(businessId) {
    const postObject = {
      businessType: {
        id: businessId,
      },
    };
    FetchServerData.callPostService(ActiveForBusinessType_Url, postObject)
      .then((response) => {
        let output = response;
        if (output.status === "SUCCESS") {
          let businessUseCaseList = output.data.businessUseCaseList;
          businessUseCaseList.map((item, index) => {
            if (index === 0) {
              item.isChecked = true;
              const tabPlanList = item.planTypes
                .filter(plan => plan.type !== "LegacyOntime")
                .sort((a, b) => a.displaySequence - b.displaySequence);

              this.setState({
                planList: item.plans,
                tabPlanList: tabPlanList,
                businessUseCase: businessUseCaseList[0],
              });
              return item;
            }
          });

          this.setState({ businessUseCaseList: businessUseCaseList });
        } else {
        }
      })
      .catch((error) => { });
  }

  handleBusinessTypeChange(selectedType) {
    let businessId = selectedType?.id;
    this.getStaticData(selectedType?.businessDomainName);
    this.getBusinessUsecase(businessId);
    this.setState({
      businessType: selectedType,
      isUseCases: true,
      planList: [],
      selectedTab: 0,
    });
  }

  getPlanCategory(selectedPlanId) {
    const postObject = {
      header: {},
      businessUseCase: {
        id: selectedPlanId,
      },
    };
    FetchServerData.callPostService(
      "/planms/getActiveForBusinessUseCase",
      postObject
    )
      .then((response) => {
        let output = response;
        if (output.status === "SUCCESS") {
          let planList = output.data.planList;
          planList.sort((a, b) => b.displaysequence - a.displaysequence);
          let tabPlanList = planList.reduce((unique, o) => {
            if (o.planType?.type === "LegacyOntime") {
              return unique;
            }
            if (
              !unique.some(
                (obj) => obj.planType?.type === o.planType?.type
              )
            ) {
              unique.push(o);
            }
            return unique;
          }, []);

          this.setState({
            planList: planList,
            tabPlanList: tabPlanList,
          });
        } else {
        }
      })
      .catch((error) => { });
  }

  getCountryList() {
    FetchServerData.callPostService(GetCountryList_Url, {}).then((output) => {
      if (output.status === "SUCCESS") {
        this.countryListArray = output.data;
        this.setState({
          render: true,
        });
      } else {
      }
    });
  }

  setStatesForCountry(selectedCountry) {
    this.setState({
      country: selectedCountry,
      selectedCountry: selectedCountry,
    });
  }

  handleStateChange(selectedState) {
    this.state.state = selectedState;
    this.setState({ state: selectedState });
    if (undefined !== this.onChange && null !== this.onChange) {
      this.onChange(this.state);
    }
  }
  handleTimeZoneChange(selectedTimezone) {
    this.state.timeZone = selectedTimezone;
    this.setState({ timeZone: selectedTimezone });
    if (undefined !== this.onChange && null !== this.onChange) {
      this.onChange(this.state);
    }
  }
  handleLine1Change(e) {
    let val = e.target.value;
    let res = val.substring(0, 128);
    if (res.length < 128) {
      this.setState({ line: res });
    } else {
      Utils.maxFieldLength(128);
    }
  }

  handleLine2Change(e) {
    this.setState({ line2: e.target.value });
  }

  handleCityChange(e) {
    let val = Utils.toCamelCase(e.target.value);
    let res = val.substring(0, 128);
    if (res.length < 128) {
      this.setState({ city: res });
    } else {
      Utils.maxFieldLength(128);
    }
  }

  handlePinCodeChange(e) {
    let val = e.target.value;
    if (Utils.equalsIgnoreCase(this.state.country?.name, "Canada")) {
      let res = val.substring(0, 7);
      if (res.length < 7) {
        this.setState({ zipcode: res, zipCodeErrorMessageText: "" });
      }
    } else {
      let res = val.substring(0, 6);
      if (res.length < 6) {
        this.setState({ zipcode: res, zipCodeErrorMessageText: "" });
      }
    }
  }


  handleCountryChange(selectedCountry) {
    if (Utils.equalsIgnoreCase(selectedCountry.namecode, "Other")) {
      this.getOtherCountryList();
      this.setState({
        otherCountryShow: true,
        country: selectedCountry,
      });
      return false;
    } else {
      this.setState({
        otherCountryShow: false,
      });
    }
    if (null === selectedCountry || selectedCountry === "") {
      this.stateListArray = [];
      this.setState({
        stateClear: !this.state.stateClear,
      });
      return;
    }
    this.state.country = selectedCountry;
    if (undefined !== this.onChange && null !== this.onChange) {
      this.onChange(this.state);
    }
    this.setState({
      country: selectedCountry,
      state: null,
      timeZone: null,
    });

    const postObject = {
      header: {},
      country: { id: selectedCountry.id },
    };
    FetchServerData.callPostService(GetCountryList_Url, postObject).then(
      (output) => {
        if (output.status === "SUCCESS") {
          let stateTimezoneList = output.data.country;
          this.stateListArray = stateTimezoneList.states;
          this.timeZoneListArray = stateTimezoneList.timezones;
          this.setState({
            render: true,
          });
        } else {
        }
      }
    );
  }
  handleEventCountryChange(selectedCountry) {
    if (Utils.equalsIgnoreCase(selectedCountry.namecode, "Other")) {
      this.getOtherCountryList();
      this.setState({
        otherCountryShow: true,
        eventCountry: selectedCountry,
      });
      return false;
    }
    if (null === selectedCountry || selectedCountry === "") {
      this.stateListArray = [];
      this.setState({
        stateClear: !this.state.stateClear,
      });
      return;
    }
    this.state.eventCountry = selectedCountry;
    if (undefined !== this.onChange && null !== this.onChange) {
      this.onChange(this.state);
    }

    this.setState({
      eventCountry: selectedCountry,
      eventState: null,
      eventTimeZone: null,
    });

    const postObject = {
      header: {},
      country: { id: selectedCountry.id },
    };
    FetchServerData.callPostService(GetCountryList_Url, postObject).then(
      (output) => {
        if (output.status === "SUCCESS") {
          let stateTimezoneList = output.data.country;
          this.stateListArray = stateTimezoneList.states;
          this.timeZoneListArray = stateTimezoneList.timezones;
          this.setState({
            render: true,
          });
        } else {
        }
      }
    );
  }

  handleEventStateChange(selectedState) {
    this.state.eventState = selectedState;
    this.setState({ eventState: selectedState });
    if (undefined !== this.onChange && null !== this.onChange) {
      this.onChange(this.state);
    }
  }
  handleEventTimeZoneChange(selectedTimezone) {
    this.state.eventTimeZone = selectedTimezone;
    this.setState({ eventTimeZone: selectedTimezone });
    if (undefined !== this.onChange && null !== this.onChange) {
      this.onChange(this.state);
    }
  }

  getOtherCountryList() {
    const postObject = {};
    FetchServerData.callPostService("/countryms/getAll", postObject)
      .then((response) => {
        let output = response;
        if (output.status === "SUCCESS") {
          let countryList = output.data.countryList;
          this.setState({
            otherCountryList: countryList,
            otherCountry: countryList[0],
          });
        } else {
        }
      })
      .catch((error) => { });
  }

  handleOtherCountryChange(selectedCountry) {
    if (undefined !== this.onChange && null !== this.onChange) {
      this.onChange(this.state);
    }
    this.setState({
      otherCountry: selectedCountry,
      state: null,
    });

    const postObject = {
      header: {},
      country: { id: selectedCountry.id },
    };
    FetchServerData.callPostService(GetCountryList_Url, postObject).then(
      (output) => {
        if (output.status === "SUCCESS") {
          let stateTimezoneList = output.data.country;
          this.stateListArray = stateTimezoneList.states;
          this.timeZoneListArray = stateTimezoneList.timezones;
          this.setState({
            render: true,
          });
        } else {
        }
      }
    );
  }

  handleBillingStateChange(selectedState) {
    this.state.state = selectedState;
    this.setState({ billingState: selectedState });
    if (undefined !== this.onChange && null !== this.onChange) {
      this.onChange(this.state);
    }
  }
  handleBillingTimeZoneChange(selectedTimezone) {
    this.state.timeZone = selectedTimezone;
    this.setState({ billingTimeZone: selectedTimezone });
    if (undefined !== this.onChange && null !== this.onChange) {
      this.onChange(this.state);
    }
  }
  handleBillingLine1Change(e) {
    let val = e.target.value;
    let res = val.substring(0, 128);
    if (res.length < 128) {
      this.setState({ billingLine: res });
    } else {
      Utils.maxFieldLength(128);
    }
  }

  handleBillingCityChange(e) {
    let val = Utils.toCamelCase(e.target.value);
    let res = val.substring(0, 128);
    if (res.length < 128) {
      this.setState({ billingCity: res });
    } else {
      Utils.maxFieldLength(128);
    }
  }

  handleBillingPinCodeChange(e) {
    let val = e.target.value;
    let res = val.substring(0, 6);
    if (res.length < 6) {
      this.setState({ billingZipcode: res, zipCodeErrorMessageText: "" });
    }
  }

  handleBillingCountryChange(selectedCountry) {
    if (null === selectedCountry || selectedCountry === "") {
      this.stateListArray = [];
      this.setState({
        stateClear: !this.state.stateClear,
      });
      return;
    }
    this.state.billingCountry = selectedCountry;
    if (undefined !== this.onChange && null !== this.onChange) {
      this.onChange(this.state);
    }

    this.setState({
      billingCountry: selectedCountry,
      state: null,
    });

    const postObject = {
      header: {},
      country: { id: selectedCountry.id },
    };
    FetchServerData.callPostService(GetCountryList_Url, postObject).then(
      (output) => {
        if (output.status === "SUCCESS") {
          let stateTimezoneList = output.data.country;
          this.stateListArray = stateTimezoneList.states;
          this.timeZoneListArray = stateTimezoneList.timezones;
          this.setState({
            render: true,
          });
        } else {
        }
      }
    );
  }

  handleTaxDocFileChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      this.setState({ selectedTaxDocFile: file });
      this.optinFileHandler(file);
    }
  };
  handleTaxDocDrop = (e) => {
    e.preventDefault();
    const file = e.dataTransfer.files[0];
    if (file) {
      this.setState({ selectedTaxDocFile: file, isTaxDocDragging: false });
      this.optinFileHandler(file);
    }
  };

  handleTaxDocDragOver = (e) => {
    e.preventDefault();
    this.setState({ isTaxDocDragging: true });
  };

  handleTaxDocDragLeave = (e) => {
    e.preventDefault();
    this.setState({ isTaxDocDragging: false });
  };

  optinFileHandler(file) {
    // const file = e.target.files[0];
    if (!file) return;

    const allowedTypes = ["image/jpeg", "application/pdf"];

    if (!allowedTypes.includes(file.type)) {
      this.setState({
        taxErrorMessage: true,
        selectedTaxDocFile: null,
        responseArray: [],
      });
      return;
    }

    this.setState(
      {
        taxErrorMessage: false,
        selectedTaxDocFile: file,
        responseArray: [],
      },
      () => this.uploadOptInFile()
    );

    const reader = new FileReader();
    reader.readAsDataURL(file);
  }

  uploadOptInFile(e) {
    // e.preventDefault();
    if (
      !this.state.selectedTaxDocFile.name ||
      this.state.selectedTaxDocFile.name === ""
    ) {
      PtsAlert.error("Please select file to upload");
      return;
    }
    const formData = new FormData();

    // Update the formData object
    formData.append(
      "file",
      this.state.selectedTaxDocFile,
      this.state.selectedTaxDocFile?.name
    );
    formData.append("sessionid", "");
    formData.append("userid", "");
    formData.append("tid", "");
    formData.append("isAp", false);
    formData.append("appclient", "W");

    FetchServerData.callPostService(UploadTaxExcDoc_Url, formData).then(
      (output) => {
        if (output.status === "SUCCESS") {
          let uploadFileDetails = output.data;
          if (uploadFileDetails?.url !== null) {
            let fileName = uploadFileDetails?.filename;
            let urlArr = fileName.split(".");
            let fileType = urlArr[1];
            this.setState({
              newUrl: uploadFileDetails?.url,
              fileType: fileType,
              showFileView: true,
              npoTaxDocumentId: uploadFileDetails?.id,
            });
          }
        } else {
        }
      }
    );
  }

  removeTaxExemptDocInBackend() {
    const postObject = {
      header: {},
      documentId: this.state.npoTaxDocumentId,
    };
    FetchServerData.callPostService(
      "/regms/deleteTaxExcemptDoc",
      postObject
    ).then((output) => {
      if (output.status === "SUCCESS") {
        PtsAlert.success(output.message);
        this.setState({
          open: false,
          npoTaxDocumentId: "",
          showFileView: false,
          uploadFileShow: true,
        });
      } else {
      }
    });
  }

  resetFile() {
    document.getElementsByName("file")[0].value = null;
  }
  createAccountInBackend() {
    let crmIntegrationId = "";
    if (this.state.crmIntegration) {
      crmIntegrationId = this.state.crmIntegration.id;
    }

    let textingCountries = [];
    for (let i = 0; i < this.state.textingCountryList.length; i++) {
      textingCountries.push({
        country: { id: this.state.textingCountryList[i].id },
      });
    }

    const postObject = {
      registration: {
        credential: this.state.password,
        email: this.state.email,
        firstName: this.state.firstName,
        id: null,
        jobtitle: this.state.jobTitle,
        lastName: this.state.lastName,
        orgAddressCity: this.state.city,
        orgAddressLine: this.state.line,
        orgAddressState: this.state.state.id,
        orgTimezone: this.state.timeZone.id,
        orgAddressZipcode: this.state.zipcode,
        orgCompanyType: this.state.companyType.id,
        smstandc: this.state.smsTAndCUrl,
        orgPrivacyPolicy: this.state.smsPrivacyPolicyUrl,
        orgBusinessIndustry: this.state.businessIndustry.id,
        orgBusinessType: this.state.orgBusinessType.id,
        orgEin: this.state.eInNumber,
        orgName: this.state.businessName,
        // orgPaymentCardcvv: this.state.cvvCode,
        // orgPaymentCardmonth: this.state.cardMonth,
        // orgPaymentCardname: this.state.cardOwnerName,
        // orgPaymentCardFirstname: this.state.cardFirstName,
        // orgPaymentCardLastname: this.state.cardLastName,
        // orgPaymentCardnumber: this.state.cardNumber?.replace(/ /g, ""),
        // orgPaymentCardphone: "",
        // orgPaymentCardtype: this.state.cardType,
        // orgPaymentCardyear: this.state.cardYear,
        // paymentCardAddressCity: this.state.billingCity,
        // paymentCardAddressLine: this.state.billingLine,
        // paymentCardAddressState: this.state.billingState?.id,
        // paymentCardAddressZipcode: this.state.billingZipcode,
        orgTandc: this.state.smsTAndCUrl,
        orgPhone: this.state.officePhoneNumber,
        orgPhoneCountrycode:
          this.state.officeCountryCode === ""
            ? "+1"
            : this.state.officeCountryCode,
        orgPlan: this.state.selectedPlanId,
        orgWebsite: this.state.companyWebsite,
        phoneCountrycode:
          this.state.countryCode === "" ? "+1" : this.state.countryCode,
        phone: this.state.phoneNumber,
        status: {},
        tenant: {},
        verificationcode: "",
        optinCollectionOption: {
          id: this.state.optInCollectionFromAudience,
        },
        neonOrgId: this.state.neonOrgId,
        neonOrgApikey: this.state.neonOrgApiKey,
        crmintegration: {
          id: crmIntegrationId,
        },
        paymentServicestype: this.state.paymentServicesType,
        orgPaymentPaypalid: this.state.payPal,
        isNpoaxExempt: this.state.taxExYes,
        npoTaxdocumentid: this.state.npoTaxDocumentId,
        textingCountries: textingCountries,
        eventName: this.state.eventName,
        eventStartDate: this.state.startDate,
        eventEndDate: this.state.endDate,
        eventLocation: this.state.location,
        eventCountryId: this.state.eventCountry?.id,
        eventStateId: this.state.eventState?.id,
        eventTimezoneId: this.state.eventTimeZone?.id,
        isConnectToCvent: this.state.isConnectToCvent,
        eventCode: this.state.ceventCode,
        eventCventCarryovertypeId: this.state.ceventCarryover?.id,
        eventRegConfirmationText: this.state.eventRegConfirmationText,
      },
    };
    FetchServerData.callPostService(Registration_Url, postObject)
      .then((response) => {
        let output = response;
        let registration = response.data.registration;
        if (output.status === "SUCCESS") {
          window.scroll(0, 0);
          this.setState({
            activeAccountDetailsStep: false,
            activeEventDetailsStep: false,
            activeCompanyDetailsStep: false,
            activeUseCaseDetailsStep: false,
            activeGivBeePlanStep: false,
            activeBillingLinksStep: true,
            activeIntegrationStep: false,
            registration: registration,
            billingStepClick: true,
          });
          // this.props.navigate("/verifyAccount", {
          //   state: { email: this.state.email },
          // });
        } else {
        }
      })
      .catch((error) => { });
  }
  searchExistingEmail() {
    let email = this.state.email;
    if (!Utils.isNullOrEmpty(this.state.email)) {
      const postObject = {
        email: this.state.email,
      };
      if (Utils.emailValidation(email)) {
        FetchServerData.callPostService(
          CheckExistingEmail_Url,
          postObject
        ).then((output) => {
          if (output.status === "SUCCESS") {
          } else {
            if (output.errorCode === "REGISTRATION_EXISTS") {
              this.setState({
                email: "",
              });
            }
          }
        });
      } else {
        PtsAlert.error("Enter valid User ID format john.doe@email.com");
      }
    }
  }

  handleHelpContentsOpen() {
    this.setState({ openBlackbaud: true });
  }

  handleHelpContentsClose() {
    this.setState({ openBlackbaud: false });
  }

  helpContentsDialogBox() {
    return (
      <Dialog
        open={this.state.openBlackbaud}
        onClose={this.handleHelpContentsClose.bind(this)}
        maxWidth="xl"
        className="QRCodeDialogue"
      >
        <DialogTitle
          id="scroll-dialog-title"
          style={{ backgroundColor: "#37517e" }}
        >
          <span style={{ color: "#fff" }}>
            How to connect GivBee to your Blackbaud account
          </span>
        </DialogTitle>
        <IconButton
          aria-label="close"
          onClick={this.handleHelpContentsClose.bind(this)}
          style={{
            position: "absolute",
            right: 8,
            top: 4,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <CloseIcon style={{ color: "#fff", fontWeight: "600" }} />
        </IconButton>
        <DialogContent>
          <div
            className="row d-flex"
            style={{
              width: "100%",
              color: "#000",
              fontSize: "small",
              padding: "0.5em",
            }}
          >
            <p>
              <span className="fw-bold fs-6">
                Part 1: Connect your Blackbaud account to the GivBee application
              </span>
              <ol className="m-2">
                <li className="mb-2">
                  Go to the Blackbaud Application webpage:
                  <a
                    className="anchortag ms-1"
                    target="blank"
                    href="https://app.blackbaud.com/marketplace/manage"
                  >
                    https://app.blackbaud.com/marketplace/manage
                  </a>
                </li>
                <li className="mb-2">
                  Click "Connect app" Button and search for the GivBee
                  application with App ID 80a6d929-5683-43aa-959b-a6993aa4ef96
                </li>
                <li>Click "CONNECT</li>
              </ol>
            </p>
            <p>
              <span className="fw-bold fs-6">
                Part 2: Log into your Blackbaud account
              </span>
              <ol className="ms-2 mt-2">
                <li className="mb-2">
                  From within your new GivBee account, go to Account
                  Settings-Integrations and click "Connect" This will redirect
                  you to the account login page on Blackbaud's site
                </li>
                <li>
                  After logging in to your Blackbaud account, you will be
                  redirected back to your GivBee account where the integration
                  status will apper as "Connected".
                </li>
              </ol>
            </p>
          </div>
        </DialogContent>
      </Dialog>
    );
  }

  getDemoEventURLToBackend() {
    const postObject = {
      businessDomain: this.state.businessType?.businessDomainName,
      userInfo: {
        firstName: this.state.firstName,
        lastName: this.state.lastName,
        email: this.state.email,
      },
    };
    FetchServerData.callPostService(
      "/calendleyms/getAccountSetupEventUrl",
      postObject
    ).then((response) => {
      if (response.status === "SUCCESS") {
        let output = response.data;
        window.open(output.calendlyEventUrl);
      } else {
      }
    });
  }

  scheduleCall() {
    return (
      <Dialog
        open={this.state.isScheduleCall}
        onClose={this.handalScheduleCallClose.bind(this)}
        style={{ padding: "2em" }}
      // maxWidth="xl"
      // className="QRCodeDialogue"
      >
        <DialogTitle id="scroll-dialog-title">
          <span>Please Fill in information</span>
        </DialogTitle>
        <IconButton
          aria-label="close"
          onClick={this.handalScheduleCallClose.bind(this)}
          style={{
            position: "absolute",
            right: 8,
            top: 4,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <CloseIcon style={{ fontWeight: "600" }} />
        </IconButton>
        <DialogContent style={{ textAlign: "center", width: "380px" }}>
          <div className="row justify-content-center ms-4 me-4">
            <div
              className="col-sm-12"
              style={{
                textAlign: "left",
                fontSize: "18px",
                alignSelf: "center",
              }}
            >
              <div className="row">
                <div className="col-sm-12">
                  <label className="form-label" htmlFor="multiStepsFirstName">
                    First Name
                  </label>
                  <input
                    title=""
                    required
                    autoComplete="off"
                    type="text"
                    id="multiStepsFirstName"
                    name="multiStepsFirstName"
                    className="form-control"
                    value={this.state.firstName}
                    onChange={this.handleFirstNameChange.bind(this)}
                  />
                </div>
              </div>
              <div className="row g-3">
                <div className="col-sm-12">
                  <label className="form-label" htmlFor="multiStepsLastName">
                    Last Name
                  </label>
                  <input
                    title=""
                    required
                    autoComplete="off"
                    type="text"
                    value={this.state.lastName}
                    onChange={this.handleLastNameChange.bind(this)}
                    id="multiStepsFirstName"
                    name="multiStepsFirstName"
                    className="form-control"
                  />
                </div>
              </div>
              <div className="row g-3">
                <div className="col-sm-12">
                  <label className="form-label" htmlFor="multiStepsEmail">
                    Email Address
                  </label>
                  <input
                    title=""
                    required
                    autoComplete="off"
                    type="email"
                    value={this.state.email}
                    onChange={this.handleEmailChange.bind(this)}
                    id="multiStepsFirstName"
                    name="multiStepsFirstName"
                    className="form-control"
                    aria-label="john.doe"
                  />
                </div>
              </div>
            </div>
          </div>
          <DialogActions style={{ justifyContent: "center" }}>
            <div
              className="row text-center p-2"
              style={{ textAlign: "center" }}
            >
              <Button
                type="button"
                variant="contained"
                size="small"
                style={{
                  background: "#37517e",
                  color: "white",
                  marginRight: "1rem",
                  cursor: "pointer",
                  borderRadius: "5px",
                  textTransform: "capitalize",
                  fontWeight: "600",
                }}
                onClick={this.getDemoEventURLToBackend.bind(this)}
              >
                Schedule a call
              </Button>
            </div>
          </DialogActions>
        </DialogContent>
      </Dialog>
    );
  }

  handleTextingCountriesChange() {
    this.setState({
      isTextingCountries: !this.state.isTextingCountries,
    });
  }
  onRemoveTextingCountry(selectedList) {
    this.setState({
      textingCountryList: selectedList,
    });
  }

  onSelectTextingCountry(selectedList, selectedItem) {
    this.setState({
      textingCountryList: selectedList,
    });
  }

  handalScheduleCallClose() {
    this.setState({
      isScheduleCall: false,
    });
  }
  handalScheduleCallOpen() {
    this.setState({
      isScheduleCall: true,
    });
  }

  getIcon = () => {
    switch (this.state.cardType) {
      case "visa":
        return <FaCcVisa size={32} color="#1a1f71" />;
      case "master card":
        return <FaCcMastercard size={32} color="#eb001b" />;
      case "american express":
        return <FaCcAmex size={32} color="#2e77bb" />;
      case "discover":
        return <FaCcDiscover size={32} color="#f76f02" />;
      default:
        return <MdCreditCard size={32} color="#aaa" />;
    }
  };

  handleEventNameChange(e) {
    this.setState({ eventName: e.target.value });
  }
  handleEventTypeChange(selectedValue) {
    this.setState({ eventType: selectedValue });
  }

  handleStartDateChange(date) {
    let fromDate = Date.parse(date);
    let toDate = Date.parse(this.state.endDate);
    if (this.state.endDate === null && date === null) {
      this.setState({
        startDate: date,
        eventDateErrorMassage: false,
        errorMassage: false,
      });
    } else if (date === null) {
      this.setState({
        startDate: date,
        eventDateErrorMassage: false,
        errorMassage: true,
      });
    } else if (fromDate > toDate) {
      this.setState({
        startDate: date,
        eventDateErrorMassage: true,
        errorMassage: false,
      });
    } else {
      this.setState({
        startDate: date,
        eventDateErrorMassage: false,
        errorMassage: false,
      });
    }
  }

  handleEndDateChange(date) {
    let fromDate = Date.parse(this.state.startDate);
    let toDate = Date.parse(date);

    if (this.state.startDate === null && date === null) {
      this.setState({
        endDate: date,
        eventDateErrorMassage: false,
        errorMassage: false,
      });
    } else if (this.state.startDate === null) {
      this.setState({
        endDate: date,
        eventDateErrorMassage: false,
        errorMassage: true,
      });
    } else if (fromDate > toDate) {
      this.setState({
        endDate: date,
        eventDateErrorMassage: true,
        errorMassage: false,
      });
    } else {
      this.setState({
        endDate: date,
        eventDateErrorMassage: false,
        errorMassage: false,
      });
    }
  }

  handleIsConnectToCventChange(e) {
    this.setState({
      isConnectToCvent: e.target.checked,
    });
  }

  handleCeventCodeChange(e) {
    this.setState({ ceventCode: e.target.value });
  }

  handleCeventCarryoverChange(selectedValue) {
    this.setState({ ceventCarryover: selectedValue });
  }

  handleEventRegConfirmationTextChange(e) {
    this.setState({ eventRegConfirmationText: e.target.value });
  }

  onClickShowFile() {
    this.setState({ showFile: true });
  }
  handleClose() {
    this.setState({ showFile: false });
  }

  viewTaxDocument() {
    return (
      <Dialog
        open={this.state.showFile}
        onClose={this.handleClose.bind(this)}
        maxWidth="xl"
        className="taxDocDialogue"
        onHide={this.close}
        style={{ padding: "1em" }}
      >
        <DialogTitle
          id="scroll-dialog-title"
          style={{ backgroundColor: "#37517e" }}
        >
          <span style={{ color: "#fff" }}>Tax Document</span>
        </DialogTitle>
        <IconButton
          aria-label="close"
          onClick={this.handleClose.bind(this)}
          style={{
            position: "absolute",
            right: 8,
            top: 4,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <CloseIcon style={{ color: "#fff", fontWeight: "600" }} />
        </IconButton>
        <DialogContent>
          <div
            className="text-center"
            md={12}
            style={{
              width: "100%",
              height: this.state.fileType === "pdf" ? "80vh" : "100%",
              color: "#000",
              fontSize: "small",
              padding: "0.5em",
            }}
          >
            {this.state.fileType === "txt" || this.state.fileType === "pdf" ? (
              <iframe
                src={this.state.newUrl}
                title="Preview content"
                style={{ width: "100%", height: "100%", border: "none" }}
              />
            ) : this.state.fileType === "jpeg" ||
              this.state.fileType === "jpg" ? (
              <img
                src={this.state.newUrl}
                alt="Preview"
                style={{ width: "60%", height: "100%", objectFit: "contain" }}
              />
            ) : (
              <div style={{ height: "100%" }}>
                <FileViewer
                  fileType={this.state.fileType}
                  filePath={this.state.newUrl}
                  onError={this.onError}
                />
              </div>
            )}
          </div>
        </DialogContent>
      </Dialog>
    );
  }

  handleStepClick = (stepKey) => {
    this.setState({
      activeGivBeePlanStep: stepKey === "plan",
      activeCompanyDetailsStep: stepKey === "company",
      activeAccountDetailsStep: stepKey === "account",
      activeEventDetailsStep: stepKey === "event",
      activeIntegrationStep: stepKey === "integration",
      activeBillingLinksStep: stepKey === "billing",
    });
  };

  isStepClickable = (step) => {
    const {
      companyStepClickable,
      accountStepClickable,
      eventStepClickable,
      integrationStepClickable,
    } = this.state;

    switch (step) {
      case "plan":
        return (
          companyStepClickable ||
          accountStepClickable ||
          eventStepClickable ||
          integrationStepClickable
        );

      case "company":
        return (
          companyStepClickable ||
          accountStepClickable ||
          eventStepClickable ||
          integrationStepClickable
        );

      case "account":
        return (
          accountStepClickable ||
          eventStepClickable ||
          integrationStepClickable
        );

      case "event":
        return eventStepClickable || integrationStepClickable;

      case "integration":
        return integrationStepClickable;

      case "billing":
        return false;

      default:
        return false;
    }
  };

  render() {
    const { error, passwordFocussed } = this.state;
    this.addressRef = React.createRef();
    this.billingAddressRef = React.createRef();
    const colors = [
      "#9bdef9",
      "#ff9999",
      // "#d4dfd1",
      "#e4b982",
      "#67e0e9",
      "#e8b1c4",
      // "#67e0e9",
      // "#e8b1c4",
      "#7ab9de",
      "#84bfcf",
      "#f4eade",
      "#ffb6b9",
    ];
    const planTitleColors = [
      "#26b9f2",
      "#ff6666",
      // "#729669",
      "#d18a2e",
      "#20d2df",
      "#c43b6b",
      // "#20d2df",
      // "#c43b6b",
      "#3394cc",
      "#479fb8",
      "#bf8640",
      "#ff0008",
    ];

    let monthlyPlanListArr = [];
    let yearlyPlanListArr = [];
    let onetimePlanListArr = [];
    let dailyPlanListArr = [];
    let customOnetimePlanListArr = [];
    for (
      let i = 0;
      i <
      this.state.planList.sort((a, b) => a.displaysequence - b.displaysequence)
        ?.length;
      i++
    ) {
      if (
        Utils.equalsIgnoreCase(
          this.state.planList[i].planType?.type,
          SUBSCRIPTION_TYPES.payMonthly
        )
      ) {
        monthlyPlanListArr.push(this.state.planList[i]);
      } else if (
        Utils.equalsIgnoreCase(
          this.state.planList[i].planType?.type,
          SUBSCRIPTION_TYPES.payYearly
        )
      ) {
        yearlyPlanListArr.push(this.state.planList[i]);
      } else if (
        Utils.equalsIgnoreCase(
          this.state.planList[i].planType?.type,
          SUBSCRIPTION_TYPES.payOnetime
        )
      ) {
        onetimePlanListArr.push(this.state.planList[i]);
      } else if (
        Utils.equalsIgnoreCase(
          this.state.planList[i].planType?.type,
          SUBSCRIPTION_TYPES.customOnetime
        )
      ) {
        customOnetimePlanListArr.push(this.state.planList[i]);
      } else {
        dailyPlanListArr.push(this.state.planList[i]);
      }
    }
    const enableCountryCode = process.env.REACT_APP_ENABLE_COUNTRYCODE === "true";
    return (
      <>
        <Header />
        <div
          className="authentication-wrapper authentication-cover"
          style={{ padding: "0em 2em" }}
        >
          <div className="authentication-inner row m-0">
            <div className="col-lg-12 align-items-center authentication-bg p-sm-5 p-3">
              <div className="px-1000">
                <div
                  id="multiStepsValidation"
                  className="bs-stepper shadow-none"
                >
                  <div className="bs-stepper-header border-bottom-0">
                    <div
                      data-target="#givBeeSolutionsValidation"
                      className={
                        this.state.activeGivBeePlanStep === true
                          ? "step active"
                          : "step"
                      }
                    >
                      <button type="button" className="step-trigger" onClick={() => this.handleStepClick("plan")}>
                        <span className="bs-stepper-circle">
                          <img src={ChoosePlanIcon} alt="Choose a plan" style={{ height: "25px" }} />
                        </span>
                        <span className="bs-stepper-label mt-1">
                          <span className="bs-stepper-title">
                            Choose a Plan
                          </span>
                        </span>
                      </button>
                    </div>
                    <div className="line">
                      <i className="bx bx-chevron-right" style={{ color: "#37517e" }} />
                    </div>
                    <div
                      data-target="#companyDetailsValidation"
                      className={
                        this.state.activeCompanyDetailsStep === true
                          ? "step active"
                          : "step"
                      }
                    >
                      <button type="button" className="step-trigger" style={{
                        opacity: this.state.companyStepClickable ? 1 : 0.6,
                        cursor: this.state.companyStepClickable ? "pointer" : "not-allowed",
                      }} onClick={() => this.isStepClickable("company") && this.handleStepClick("company")}>
                        <span className="bs-stepper-circle">
                          <img src={WorkPlaceIcon} alt="Choose a plan" style={{ height: "27px" }} />
                        </span>
                        <span className="bs-stepper-label mt-1">
                          <span className="bs-stepper-title">
                            {" "}
                            Company Information
                          </span>
                        </span>
                      </button>
                    </div>
                    <div className="line">
                      <i className="bx bx-chevron-right" style={{ color: "#37517e" }} />
                    </div>
                    <div
                      className={
                        this.state.activeAccountDetailsStep === true
                          ? "step active"
                          : "step"
                      }
                      data-target="#accountDetailsValidation"
                    >
                      <button type="button" className="step-trigger" style={{
                        opacity: this.state.accountStepClickable ? 1 : 0.6,
                        cursor: this.state.accountStepClickable ? "pointer" : "not-allowed",
                      }} onClick={() => this.isStepClickable("account") && this.handleStepClick("account")}>
                        <span className="bs-stepper-circle">
                          <img src={UserIcon} alt="Choose a plan" style={{ height: "25px" }} />
                        </span>
                        <span className="bs-stepper-label mt-1">
                          <span className="bs-stepper-title">
                            Account Details
                          </span>
                        </span>
                      </button>
                    </div>

                    <div className="line">
                      <i className="bx bx-chevron-right" style={{ color: "#37517e" }} />
                    </div>
                    {(this.state.businessType?.businessDomainName === "EventText" && this.state.selectedPlan?.planType?.type === "Onetime") &&
                      <>
                        < div
                          className={
                            this.state.activeEventDetailsStep === true
                              ? "step active"
                              : "step"
                          }
                          data-target="#eventDetailsValidation"
                        >
                          <button type="button" className="step-trigger"
                            style={{
                              opacity: this.state.eventStepClickable ? 1 : 0.6,
                              cursor: this.state.eventStepClickable ? "pointer" : "not-allowed",
                            }} onClick={() => this.isStepClickable("event") && this.handleStepClick("event")} >
                            <span className="bs-stepper-circle">
                              <img src={EventIcon} alt="Choose a plan" style={{ height: "28px" }} />
                            </span>
                            <span className="bs-stepper-label mt-1">
                              <span className="bs-stepper-title">
                                Event Details
                              </span>
                            </span>
                          </button>
                        </div>
                        <div className="line">
                          <i className="bx bx-chevron-right" style={{ color: "#37517e" }} />
                        </div>
                      </>
                    }
                    <div
                      data-target="#integrationValidation"
                      className={
                        this.state.activeIntegrationStep === true
                          ? "step active"
                          : "step"
                      }
                    >
                      <button type="button" className="step-trigger" style={{
                        opacity: this.state.integrationStepClickable ? 1 : 0.6,
                        cursor: this.state.integrationStepClickable ? "pointer" : "not-allowed",
                      }} onClick={() => this.isStepClickable("integration") && this.handleStepClick("integration")}>
                        <span className="bs-stepper-circle">
                          <img src={IntegrationIcon} alt="Choose a plan" style={{ height: "32px" }} />
                        </span>
                        <span className="bs-stepper-label mt-1">
                          <span className="bs-stepper-title">
                            Integration
                          </span>
                          <span className="bs-stepper-subtitle">
                          </span>
                        </span>
                      </button>
                    </div>
                    <div className="line">
                      <i className="bx bx-chevron-right" style={{ color: "#37517e" }} />
                    </div>
                    <div
                      data-target="#billingLinksValidation"
                      className={
                        this.state.activeBillingLinksStep === true
                          ? "step active"
                          : "step"
                      }
                    >
                      <button type="button" className="step-trigger" style={{
                        opacity: this.state.billingStepClick ? 1 : 0.6,
                        cursor: this.state.billingStepClick ? "pointer" : "not-allowed",
                      }} onClick={() => this.isStepClickable("billing") && this.handleStepClick("billing")} >
                        <span className="bs-stepper-circle">
                          <img src={BillingIcon} alt="Choose a plan" style={{ height: "28px" }} />
                        </span>
                        <span className="bs-stepper-label mt-1">
                          <span className="bs-stepper-title">Billing</span>
                          <span className="bs-stepper-subtitle"></span>
                        </span>
                      </button>
                    </div>
                  </div>
                  <div
                    className="bs-stepper-content"
                    style={{ padding: "1.5rem 0.5rem" }}
                  >
                    {this.state.activeGivBeePlanStep === true && (
                      <div
                        id="givBeeSolutionsValidation"
                        className={
                          this.state.activeGivBeePlanStep === true
                            ? "content active dstepper-block fv-plugins-bootstrap5 fv-plugins-framework"
                            : '"content'
                        }
                      >
                        {!this.state.activeCustomPlanStep ? (
                          <div
                            className="card "
                            id="planDetailCard"
                            style={{ background: "#fff", width: "100%" }}
                          >
                            <div
                              className="content-header d-flex mb-3"
                              style={{ textAlign: "left", marginTop: "1em" }}
                            >
                              <div className="col-md-6">
                                {/* <h5>Pick the plan that fits your use case.</h5> */}
                              </div>
                              <div className="col-md-6 text-end">
                                <span
                                  style={{
                                    padding: "0em",
                                    color: "#000",
                                    fontSize: "14px",
                                  }}
                                >
                                  <i>
                                    Don’t see the use case or plan you need?
                                    &nbsp;
                                    <a
                                      href="https://calendly.com/givbee/givbee-introduction-to-texting"
                                      target="_blank"
                                      style={{ color: "#37517e" }}
                                      // onClick={(e) =>
                                      //   this.handalScheduleCallOpen(e)
                                      // }
                                      rel="noopener noreferrer"
                                      className="anchortag fw-bold"

                                    >
                                      Meet with us.
                                    </a>
                                  </i>
                                </span>
                              </div>
                            </div>
                            <div className="col-md-4 mb-4">
                              <label
                                className="form-label"
                                htmlFor="multiStepsState"
                              >
                                Business Type
                              </label>

                              <Autocomplete
                                id="size-small-outlined"
                                size="small"
                                fullWidth
                                disableClearable
                                autoComplete="off"
                                ListboxProps={{
                                  className: "custom-listbox",
                                }}
                                options={this.state.businessTypeList}
                                value={this.state.businessType}
                                getOptionLabel={(option) => option.name}
                                defaultValue={this.state.businessType}
                                onChange={(event, value) => {
                                  this.handleBusinessTypeChange(value);
                                }}
                                inputprops={{
                                  style: { textTransform: "capitalize" },
                                }}
                                renderInput={(params) => (
                                  <TextField
                                    {...params}
                                    placeholder="Please Select"
                                    variant="outlined"
                                    size="small"
                                    className="textField"
                                    required
                                    title=""
                                    style={{ background: "#fff" }}
                                  />
                                )}
                              />
                            </div>
                            <>
                              {this.state.businessUseCaseList.length > 0 && (
                                <div className="row g-3">
                                  <label
                                    className="form-label"
                                    htmlFor="multiStepsState"
                                  >
                                    Use Case
                                  </label>
                                  {this.state.businessUseCaseList.map(
                                    (row, index) => (
                                      <>
                                        <label
                                          key={row.id}
                                          style={{
                                            display: "inline-flex",
                                            alignItems: "center",
                                            cursor: "pointer",
                                            marginRight: "1rem",
                                          }}
                                        >
                                          <input
                                            type="radio"
                                            name="yourGroupName"
                                            value={row.id}
                                            onChange={(e) =>
                                              this.handleChange(e, row)
                                            }
                                            checked={row.isChecked}
                                            style={{ marginRight: "0.5rem" }}
                                          />
                                          <span
                                            style={{
                                              fontSize: "17px",
                                              color: "#000",
                                            }}
                                          >
                                            {row.name}
                                          </span>
                                        </label>
                                      </>
                                    )
                                  )}
                                  <div className="row g-3 mt-2">
                                    {this.state.planList?.length > 0 && (
                                      <div className="col-md-12">
                                        <div
                                          className="content-header"
                                          style={{
                                            textAlign: "left",
                                            // padding: "2em 0em 0em 0em",
                                          }}
                                        >
                                          <label
                                            className="form-label"
                                            htmlFor="multiStepsState"
                                          >
                                            Plan options:
                                          </label>
                                        </div>
                                        <div
                                          className="row mt-3"
                                        // style={{ margin: "auto" }}
                                        >
                                          <Tabs
                                            defaultIndex={
                                              this.state.selectedTab
                                            }
                                            onSelect={(k) => this.setKey(k)}
                                          >
                                            <TabList
                                              style={{
                                                listStyle: "none",
                                                margin: "0",
                                              }}
                                              className="text-start d-flex justify-content-start settingTabList ps-0"
                                            >
                                              {this.state.tabPlanList.map(
                                                (d, index) => (
                                                  <>
                                                    {d?.type !== "Onetime" &&
                                                      d?.type !== null && (
                                                        <Tab
                                                          className="tabSubscription hoverTab"
                                                          key={index}
                                                        >
                                                          {d?.description}
                                                        </Tab>
                                                      )}
                                                  </>
                                                )
                                              )}
                                            </TabList>
                                            {this.state.tabPlanList.length >
                                              0 &&
                                              this.state.tabPlanList.map(
                                                (d, index) =>
                                                  d !== null && (
                                                    <TabPanel>
                                                      <div className="row d-flex align-item-stretch">
                                                        {dailyPlanListArr.map(
                                                          (plan, index) =>
                                                            d?.type ===
                                                            SUBSCRIPTION_TYPES.payDaily && (
                                                              <div className="col-md-3 mt-4">
                                                                <div
                                                                  className="row d-flex"
                                                                  style={{
                                                                    height:
                                                                      "100%",
                                                                  }}
                                                                >
                                                                  <div className="col-md-12">
                                                                    <div
                                                                      className="box"
                                                                      data-aos="zoom-in"
                                                                      data-aos-delay={
                                                                        100
                                                                      }
                                                                      style={{
                                                                        padding:
                                                                          "0em",
                                                                        position:
                                                                          "relative",
                                                                        height:
                                                                          "100%",
                                                                      }}
                                                                      id="regPlanBox"
                                                                    >
                                                                      <div
                                                                        className="regplan-inner plan_card plan_card_bottom d-flex flex-column"
                                                                        style={{
                                                                          height:
                                                                            "100%",
                                                                        }}
                                                                      >
                                                                        <div
                                                                          className="entry-title plan_card"
                                                                          style={{
                                                                            background:
                                                                              plan.colorSecondary !==
                                                                                null
                                                                                ? plan.colorSecondary
                                                                                : colors[
                                                                                index %
                                                                                colors.length
                                                                                ],
                                                                          }}
                                                                        >
                                                                          <h3
                                                                            className="plan_card"
                                                                            style={{
                                                                              padding:
                                                                                "7px",
                                                                              color:
                                                                                "#fff",
                                                                              background:
                                                                                plan.colorPrimary !==
                                                                                  null
                                                                                  ? plan.colorPrimary
                                                                                  : planTitleColors[
                                                                                  index %
                                                                                  planTitleColors.length
                                                                                  ],
                                                                            }}
                                                                          >
                                                                            {
                                                                              plan.name
                                                                            }
                                                                          </h3>
                                                                          <div
                                                                            className="price"
                                                                            style={{
                                                                              background:
                                                                                plan.colorPrimary !==
                                                                                  null
                                                                                  ? plan.colorPrimary
                                                                                  : planTitleColors[
                                                                                  index %
                                                                                  planTitleColors.length
                                                                                  ],
                                                                            }}
                                                                          >
                                                                            <span
                                                                              style={{
                                                                                left: "20px",
                                                                              }}
                                                                            >
                                                                              {`$${Utils.formatWithCommas(
                                                                                plan.price
                                                                              )}`}
                                                                            </span>
                                                                          </div>
                                                                        </div>
                                                                        <div className="entry-content flex-grow-1 d-flex flex-column">
                                                                          <ul className="flex-grow-1">
                                                                            {plan.planItems.map(
                                                                              (
                                                                                item,
                                                                                i
                                                                              ) => (
                                                                                <li
                                                                                  key={
                                                                                    i
                                                                                  }
                                                                                  style={{
                                                                                    padding:
                                                                                      "0.2em",
                                                                                    fontWeight:
                                                                                      item?.isFontBold &&
                                                                                      "600",
                                                                                    fontStyle:
                                                                                      item?.isFontItalic &&
                                                                                      "italic",
                                                                                  }}
                                                                                >
                                                                                  {
                                                                                    item.name
                                                                                  }
                                                                                </li>
                                                                              )
                                                                            )}
                                                                          </ul>
                                                                          <div className="row p-3">
                                                                            <div className="buy_now_btn2 col-md-12 text-center mt-auto">
                                                                              <div className="btn_plan1">
                                                                                <a
                                                                                  style={{
                                                                                    borderRadius:
                                                                                      "10px",
                                                                                    backgroundColor:
                                                                                      plan.colorPrimary !==
                                                                                        null
                                                                                        ? plan.colorPrimary
                                                                                        : planTitleColors[
                                                                                        index %
                                                                                        planTitleColors.length
                                                                                        ],
                                                                                  }}
                                                                                  onClick={() =>
                                                                                    this.handleOnClickSelectedPlan(
                                                                                      plan
                                                                                    )
                                                                                  }
                                                                                >
                                                                                  Purchase
                                                                                </a>
                                                                              </div>
                                                                            </div>
                                                                          </div>
                                                                        </div>
                                                                      </div>
                                                                    </div>
                                                                  </div>
                                                                </div>
                                                              </div>
                                                            )
                                                        )}
                                                        {monthlyPlanListArr.map(
                                                          (plan, index) =>
                                                            d?.type ===
                                                            SUBSCRIPTION_TYPES.payMonthly && (
                                                              <div className="col-md-3 mt-4">
                                                                <div
                                                                  className="row d-flex"
                                                                  style={{
                                                                    height:
                                                                      "100%",
                                                                  }}
                                                                >
                                                                  <div className="col-md-12">
                                                                    <div
                                                                      className="box"
                                                                      data-aos="zoom-in"
                                                                      data-aos-delay={
                                                                        100
                                                                      }
                                                                      style={{
                                                                        padding:
                                                                          "0em",
                                                                        position:
                                                                          "relative",
                                                                        height:
                                                                          "100%",
                                                                      }}
                                                                      id="regPlanBox"
                                                                    >
                                                                      <div
                                                                        className="regplan-inner plan_card plan_card_bottom d-flex flex-column"
                                                                        style={{
                                                                          height:
                                                                            "100%",
                                                                        }}
                                                                      >
                                                                        <div
                                                                          className="entry-title plan_card"
                                                                          style={{
                                                                            background:
                                                                              plan.colorSecondary !==
                                                                                null
                                                                                ? plan.colorSecondary
                                                                                : colors[
                                                                                index %
                                                                                colors.length
                                                                                ],
                                                                          }}
                                                                        >
                                                                          <h3
                                                                            className="plan_card"
                                                                            style={{
                                                                              padding:
                                                                                "7px",
                                                                              color:
                                                                                "#fff",
                                                                              background:
                                                                                plan.colorPrimary !==
                                                                                  null
                                                                                  ? plan.colorPrimary
                                                                                  : planTitleColors[
                                                                                  index %
                                                                                  planTitleColors.length
                                                                                  ],
                                                                            }}
                                                                          >
                                                                            {
                                                                              plan.name
                                                                            }
                                                                          </h3>
                                                                          <div
                                                                            className="price"
                                                                            style={{
                                                                              background:
                                                                                plan.colorPrimary !==
                                                                                  null
                                                                                  ? plan.colorPrimary
                                                                                  : planTitleColors[
                                                                                  index %
                                                                                  planTitleColors.length
                                                                                  ],
                                                                            }}
                                                                          >
                                                                            <span
                                                                              style={{
                                                                                left: "20px",
                                                                              }}
                                                                            >
                                                                              {`$${Utils.formatWithCommas(
                                                                                plan.price
                                                                              )}`}
                                                                            </span>
                                                                          </div>
                                                                        </div>
                                                                        <div className="entry-content flex-grow-1 d-flex flex-column">
                                                                          <ul className="flex-grow-1">
                                                                            {plan?.planItems.map(
                                                                              (
                                                                                planItem,
                                                                                index
                                                                              ) => (
                                                                                <li
                                                                                  style={{
                                                                                    padding:
                                                                                      "0.2em",
                                                                                    fontWeight:
                                                                                      planItem.isFontBold &&
                                                                                      "600",
                                                                                    fontStyle:
                                                                                      planItem.isFontItalic &&
                                                                                      "italic",
                                                                                  }}
                                                                                >
                                                                                  {
                                                                                    planItem.name
                                                                                  }
                                                                                </li>
                                                                              )
                                                                            )}
                                                                          </ul>
                                                                          <div className="row p-3">
                                                                            <div className="buy_now_btn2 col-md-12 text-center mt-auto">
                                                                              <div className="btn_plan1">
                                                                                <a
                                                                                  style={{
                                                                                    borderRadius:
                                                                                      "10px",
                                                                                    backgroundColor:
                                                                                      plan.colorPrimary !==
                                                                                        null
                                                                                        ? plan.colorPrimary
                                                                                        : planTitleColors[
                                                                                        index %
                                                                                        planTitleColors.length
                                                                                        ],
                                                                                  }}
                                                                                  onClick={() =>
                                                                                    this.handleOnClickSelectedPlan(
                                                                                      plan
                                                                                    )
                                                                                  }
                                                                                >
                                                                                  Purchase
                                                                                </a>
                                                                              </div>
                                                                            </div>
                                                                          </div>
                                                                        </div>
                                                                      </div>
                                                                    </div>
                                                                  </div>
                                                                </div>
                                                              </div>
                                                            )
                                                        )}
                                                        {yearlyPlanListArr.map(
                                                          (plan, index) =>
                                                            d?.type ===
                                                            SUBSCRIPTION_TYPES.payYearly && (
                                                              <div className="col-md-3 mt-4">
                                                                <div
                                                                  className="row d-flex"
                                                                  style={{
                                                                    height:
                                                                      "100%",
                                                                  }}
                                                                >
                                                                  <div className="col-md-12">
                                                                    <div
                                                                      className="box"
                                                                      data-aos="zoom-in"
                                                                      data-aos-delay={
                                                                        100
                                                                      }
                                                                      style={{
                                                                        padding:
                                                                          "0em",
                                                                        position:
                                                                          "relative",
                                                                        height:
                                                                          "100%",
                                                                      }}
                                                                      id="regPlanBox"
                                                                    >
                                                                      <div
                                                                        className="regplan-inner plan_card plan_card_bottom d-flex flex-column"
                                                                        style={{
                                                                          height:
                                                                            "100%",
                                                                        }}
                                                                      >
                                                                        <div
                                                                          className="entry-title plan_card"
                                                                          style={{
                                                                            background:
                                                                              plan.colorSecondary !==
                                                                                null
                                                                                ? plan.colorSecondary
                                                                                : colors[
                                                                                index %
                                                                                colors.length
                                                                                ],
                                                                          }}
                                                                        >
                                                                          <h3
                                                                            className="plan_card"
                                                                            style={{
                                                                              padding:
                                                                                "7px",
                                                                              color:
                                                                                "#fff",
                                                                              background:
                                                                                plan.colorPrimary !==
                                                                                  null
                                                                                  ? plan.colorPrimary
                                                                                  : planTitleColors[
                                                                                  index %
                                                                                  planTitleColors.length
                                                                                  ],
                                                                            }}
                                                                          >
                                                                            {
                                                                              plan.name
                                                                            }
                                                                          </h3>
                                                                          <div
                                                                            className="price"
                                                                            style={{
                                                                              background:
                                                                                plan.colorPrimary !==
                                                                                  null
                                                                                  ? plan.colorPrimary
                                                                                  : planTitleColors[
                                                                                  index %
                                                                                  planTitleColors.length
                                                                                  ],
                                                                            }}
                                                                          >
                                                                            <span
                                                                              style={{
                                                                                left: "20px",
                                                                              }}
                                                                            >
                                                                              {`$${Utils.formatWithCommas(
                                                                                plan.price
                                                                              )}`}
                                                                            </span>
                                                                          </div>
                                                                        </div>
                                                                        <div className="entry-content flex-grow-1 d-flex flex-column">
                                                                          <ul className="flex-grow-1">
                                                                            {plan?.planItems.map(
                                                                              (
                                                                                planItem,
                                                                                index
                                                                              ) => (
                                                                                <li
                                                                                  style={{
                                                                                    padding:
                                                                                      "0.2em",
                                                                                    fontWeight:
                                                                                      planItem?.isFontBold &&
                                                                                      "600",
                                                                                    fontStyle:
                                                                                      planItem?.isFontItalic &&
                                                                                      "italic",
                                                                                    fontSize:
                                                                                      planItem?.isFontSmall &&
                                                                                      "12px",
                                                                                  }}
                                                                                >
                                                                                  {
                                                                                    planItem.name
                                                                                  }
                                                                                </li>
                                                                              )
                                                                            )}
                                                                          </ul>
                                                                          <div className="row p-3">
                                                                            <div className="buy_now_btn2 col-md-12 text-center mt-auto">
                                                                              <div className="btn_plan1">
                                                                                <a
                                                                                  style={{
                                                                                    borderRadius:
                                                                                      "10px",
                                                                                    backgroundColor:
                                                                                      plan.colorPrimary !==
                                                                                        null
                                                                                        ? plan.colorPrimary
                                                                                        : planTitleColors[
                                                                                        index %
                                                                                        planTitleColors.length
                                                                                        ],
                                                                                  }}
                                                                                  onClick={this.handleOnClickSelectedPlan.bind(
                                                                                    this,
                                                                                    plan
                                                                                  )}
                                                                                >
                                                                                  Purchase
                                                                                </a>
                                                                              </div>
                                                                            </div>
                                                                          </div>
                                                                        </div>
                                                                      </div>
                                                                    </div>
                                                                  </div>
                                                                </div>
                                                              </div>
                                                            )
                                                        )}
                                                        {onetimePlanListArr.map(
                                                          (plan, index) =>
                                                            d?.type ===
                                                            SUBSCRIPTION_TYPES.payOnetime && (
                                                              <div className="col-md-3 mt-4">
                                                                <div
                                                                  className="row d-flex"
                                                                  style={{
                                                                    height:
                                                                      "100%",
                                                                  }}
                                                                >
                                                                  <div className="col-md-12">
                                                                    <div
                                                                      className="box"
                                                                      data-aos="zoom-in"
                                                                      data-aos-delay={
                                                                        100
                                                                      }
                                                                      style={{
                                                                        padding:
                                                                          "0em",
                                                                        position:
                                                                          "relative",
                                                                        height:
                                                                          "100%",
                                                                      }}
                                                                      id="regPlanBox"
                                                                    >
                                                                      <div
                                                                        className="regplan-inner plan_card plan_card_bottom d-flex flex-column"
                                                                        style={{
                                                                          height:
                                                                            "100%",
                                                                        }}
                                                                      >
                                                                        <div
                                                                          className="entry-title plan_card"
                                                                          style={{
                                                                            background:
                                                                              plan.colorSecondary !==
                                                                                null
                                                                                ? plan.colorSecondary
                                                                                : colors[
                                                                                index %
                                                                                colors.length
                                                                                ],
                                                                          }}
                                                                        >
                                                                          <h3
                                                                            className="plan_card"
                                                                            style={{
                                                                              padding:
                                                                                "7px",
                                                                              color:
                                                                                "#fff",
                                                                              background:
                                                                                plan.colorPrimary !==
                                                                                  null
                                                                                  ? plan.colorPrimary
                                                                                  : planTitleColors[
                                                                                  index %
                                                                                  planTitleColors.length
                                                                                  ],
                                                                            }}
                                                                          >
                                                                            {
                                                                              plan.name
                                                                            }
                                                                          </h3>
                                                                          <div
                                                                            className="price"
                                                                            style={{
                                                                              background:
                                                                                plan.colorPrimary !==
                                                                                  null
                                                                                  ? plan.colorPrimary
                                                                                  : planTitleColors[
                                                                                  index %
                                                                                  planTitleColors.length
                                                                                  ],
                                                                            }}
                                                                          >
                                                                            <span
                                                                              style={{
                                                                                left: "10px",
                                                                              }}
                                                                            >
                                                                              {`$${Utils.formatWithCommas(
                                                                                plan.price
                                                                              )}`}
                                                                            </span>
                                                                          </div>
                                                                        </div>
                                                                        <div className="entry-content flex-grow-1 d-flex flex-column">
                                                                          <ul className="flex-grow-1">
                                                                            {plan?.planItems.map(
                                                                              (
                                                                                planItem,
                                                                                index
                                                                              ) => (
                                                                                <li
                                                                                  style={{
                                                                                    padding:
                                                                                      "0.2em",
                                                                                    fontWeight:
                                                                                      planItem?.isFontBold &&
                                                                                      "600",
                                                                                    fontStyle:
                                                                                      planItem?.isFontItalic &&
                                                                                      "italic",
                                                                                    fontSize:
                                                                                      planItem?.isFontSmall &&
                                                                                      "12px",
                                                                                  }}
                                                                                >
                                                                                  {
                                                                                    planItem.name
                                                                                  }
                                                                                </li>
                                                                              )
                                                                            )}
                                                                          </ul>
                                                                          <div className="row p-3">
                                                                            <div className="buy_now_btn2 col-md-12 text-center mt-auto">
                                                                              <div className="btn_plan1">
                                                                                <a
                                                                                  style={{
                                                                                    borderRadius:
                                                                                      "10px",
                                                                                    backgroundColor:
                                                                                      plan.colorPrimary !==
                                                                                        null
                                                                                        ? plan.colorPrimary
                                                                                        : planTitleColors[
                                                                                        index %
                                                                                        planTitleColors.length
                                                                                        ],
                                                                                  }}
                                                                                  onClick={this.handleOnClickSelectedPlan.bind(
                                                                                    this,
                                                                                    plan
                                                                                  )}
                                                                                >
                                                                                  Purchase
                                                                                </a>
                                                                              </div>
                                                                            </div>
                                                                          </div>
                                                                        </div>
                                                                      </div>
                                                                    </div>
                                                                  </div>
                                                                </div>
                                                              </div>
                                                            )
                                                        )}
                                                        {customOnetimePlanListArr.map(
                                                          (plan, index) =>
                                                            d?.type ===
                                                            SUBSCRIPTION_TYPES.customOnetime && (
                                                              <div className="col-md-3 mt-4">
                                                                <div
                                                                  className="row d-flex"
                                                                  style={{
                                                                    height:
                                                                      "100%",
                                                                  }}
                                                                >
                                                                  <div className="col-md-12">
                                                                    <div
                                                                      className="box"
                                                                      data-aos="zoom-in"
                                                                      data-aos-delay={
                                                                        100
                                                                      }
                                                                      style={{
                                                                        padding:
                                                                          "0em",
                                                                        position:
                                                                          "relative",
                                                                        height:
                                                                          "100%",
                                                                      }}
                                                                      id="regPlanBox"
                                                                    >
                                                                      <div
                                                                        className="regplan-inner plan_card plan_card_bottom d-flex flex-column"
                                                                        style={{
                                                                          height:
                                                                            "100%",
                                                                        }}
                                                                      >
                                                                        <div
                                                                          className="entry-title plan_card"
                                                                          style={{
                                                                            background:
                                                                              plan.colorSecondary !==
                                                                                null
                                                                                ? plan.colorSecondary
                                                                                : colors[
                                                                                index %
                                                                                colors.length
                                                                                ],
                                                                          }}
                                                                        >
                                                                          <h3
                                                                            className="plan_card"
                                                                            style={{
                                                                              padding:
                                                                                "7px",
                                                                              color:
                                                                                "#fff",
                                                                              background:
                                                                                plan.colorPrimary !==
                                                                                  null
                                                                                  ? plan.colorPrimary
                                                                                  : planTitleColors[
                                                                                  index %
                                                                                  planTitleColors.length
                                                                                  ],
                                                                            }}
                                                                          >
                                                                            {
                                                                              plan.name
                                                                            }
                                                                          </h3>
                                                                          <div
                                                                            className="price"
                                                                            style={{
                                                                              background:
                                                                                plan.colorPrimary !==
                                                                                  null
                                                                                  ? plan.colorPrimary
                                                                                  : planTitleColors[
                                                                                  index %
                                                                                  planTitleColors.length
                                                                                  ],
                                                                            }}
                                                                          >
                                                                            <span
                                                                              style={{
                                                                                left: "10px",
                                                                              }}
                                                                            >
                                                                              {`$${Utils.formatWithCommas(
                                                                                plan.price
                                                                              )}`}
                                                                            </span>
                                                                          </div>
                                                                        </div>
                                                                        <div className="entry-content flex-grow-1 d-flex flex-column">
                                                                          <ul className="flex-grow-1">
                                                                            {plan?.planItems.map(
                                                                              (
                                                                                planItem,
                                                                                index
                                                                              ) => (
                                                                                <li
                                                                                  style={{
                                                                                    padding:
                                                                                      "0.2em",
                                                                                    fontWeight:
                                                                                      planItem?.isFontBold &&
                                                                                      "600",
                                                                                    fontStyle:
                                                                                      planItem?.isFontItalic &&
                                                                                      "italic",
                                                                                    fontSize:
                                                                                      planItem?.isFontSmall &&
                                                                                      "12px",
                                                                                  }}
                                                                                >
                                                                                  {
                                                                                    planItem.name
                                                                                  }
                                                                                </li>
                                                                              )
                                                                            )}
                                                                          </ul>
                                                                          <div className="row p-3">
                                                                            <div className="buy_now_btn2 col-md-12 text-center mt-auto">
                                                                              <div className="btn_plan1">
                                                                                <a
                                                                                  style={{
                                                                                    borderRadius:
                                                                                      "10px",
                                                                                    backgroundColor:
                                                                                      plan.colorPrimary !==
                                                                                        null
                                                                                        ? plan.colorPrimary
                                                                                        : planTitleColors[
                                                                                        index %
                                                                                        planTitleColors.length
                                                                                        ],
                                                                                  }}
                                                                                  onClick={this.handleOnClickSelectedPlan.bind(
                                                                                    this,
                                                                                    plan
                                                                                  )}
                                                                                >
                                                                                  Purchase
                                                                                </a>
                                                                              </div>
                                                                            </div>
                                                                          </div>
                                                                        </div>
                                                                      </div>
                                                                    </div>
                                                                  </div>
                                                                </div>
                                                              </div>
                                                            )
                                                        )}
                                                      </div>
                                                    </TabPanel>
                                                  )
                                              )}
                                          </Tabs>
                                        </div>
                                      </div>
                                    )}
                                  </div>
                                </div>
                              )}
                            </>
                          </div>
                        ) : (
                          <div
                            className="card "
                            id="planDetailCard"
                            style={{ background: "#fff", width: "100%" }}
                          >
                            <>
                              <div className="row g-3">
                                <div className="col-md-12">
                                  <div className="row mt-1">
                                    {this.state.planList?.length > 0 && (
                                      <div className="col-md-12">
                                        <div className="row mt-2">
                                          {this.state.planList.map(
                                            (plan, index) => (
                                              <div className="col-md-3 mt-4">
                                                <div
                                                  className="row d-flex"
                                                  style={{
                                                    height: "100%",
                                                  }}
                                                >
                                                  <div className="col-md-12">
                                                    <div
                                                      className="box"
                                                      data-aos="zoom-in"
                                                      data-aos-delay={100}
                                                      style={{
                                                        padding: "0em",
                                                        position: "relative",
                                                        height: "100%",
                                                      }}
                                                      id="regPlanBox"
                                                    >
                                                      <div
                                                        className="regplan-inner plan_card plan_card_bottom d-flex flex-column"
                                                        style={{
                                                          height: "100%",
                                                        }}
                                                      >
                                                        <div
                                                          className="entry-title plan_card"
                                                          style={{
                                                            background:
                                                              plan.colorSecondary !==
                                                                null
                                                                ? plan.colorSecondary
                                                                : colors[
                                                                index %
                                                                colors.length
                                                                ],
                                                          }}
                                                        >
                                                          <h3
                                                            className="plan_card"
                                                            style={{
                                                              padding: "7px",
                                                              color: "#fff",
                                                              background:
                                                                plan.colorPrimary !==
                                                                  null
                                                                  ? plan.colorPrimary
                                                                  : planTitleColors[
                                                                  index %
                                                                  planTitleColors.length
                                                                  ],
                                                            }}
                                                          >
                                                            {plan.name}
                                                          </h3>
                                                          <div
                                                            className="price"
                                                            style={{
                                                              background:
                                                                plan.colorPrimary !==
                                                                  null
                                                                  ? plan.colorPrimary
                                                                  : planTitleColors[
                                                                  index %
                                                                  planTitleColors.length
                                                                  ],
                                                            }}
                                                          >
                                                            <span
                                                              style={{
                                                                left: "20px",
                                                              }}
                                                            >
                                                              {`$${Utils.formatWithCommas(
                                                                plan.price
                                                              )}`}
                                                            </span>
                                                          </div>
                                                        </div>
                                                        <div className="entry-content flex-grow-1 d-flex flex-column">
                                                          <ul className="flex-grow-1">
                                                            {plan?.planItems.map(
                                                              (
                                                                planItem,
                                                                index
                                                              ) => (
                                                                <li
                                                                  style={{
                                                                    padding:
                                                                      "0.2em",
                                                                    fontWeight:
                                                                      planItem?.isFontBold &&
                                                                      "600",
                                                                    fontStyle:
                                                                      planItem?.isFontItalic &&
                                                                      "italic",
                                                                    fontSize:
                                                                      planItem?.isFontSmall &&
                                                                      "12px",
                                                                  }}
                                                                >
                                                                  {
                                                                    planItem.name
                                                                  }
                                                                </li>
                                                              )
                                                            )}
                                                          </ul>
                                                          <div className="row p-3">
                                                            <div className="buy_now_btn2 col-md-12 text-center mt-auto">
                                                              <div className="btn_plan1">
                                                                <a
                                                                  style={{
                                                                    borderRadius:
                                                                      "10px",
                                                                    backgroundColor:
                                                                      plan.colorPrimary !==
                                                                        null
                                                                        ? plan.colorPrimary
                                                                        : planTitleColors[
                                                                        index %
                                                                        planTitleColors.length
                                                                        ],
                                                                  }}
                                                                  onClick={this.handleOnClickSelectedPlan.bind(
                                                                    this,
                                                                    plan
                                                                  )}
                                                                >
                                                                  Purchase
                                                                </a>
                                                              </div>
                                                            </div>
                                                          </div>
                                                        </div>
                                                      </div>
                                                    </div>
                                                  </div>
                                                </div>
                                              </div>
                                            )
                                          )}
                                        </div>
                                      </div>
                                    )}
                                  </div>
                                </div>
                              </div>
                            </>
                          </div>
                        )}
                        {this.scheduleCall()}
                      </div>
                    )}
                    {this.state.activeCompanyDetailsStep === true && (
                      <ValidatorForm
                        ref="form"
                        id="multiStepsForm"
                        onSubmit={this.handleNextAccountDetailsPage.bind(this)}
                      >
                        <div
                          id="companyDetailsValidation"
                          className={
                            this.state.activeCompanyDetailsStep === true
                              ? "content active dstepper-block fv-plugins-bootstrap5 fv-plugins-framework"
                              : '"content'
                          }
                        >
                          <div className="row g-3">
                            <div className="col-md-6">
                              <div className="card " id="giveBeeCard">
                                <div
                                  className="content-header"
                                  style={{
                                    display: "flex",
                                    padding: "0.5em 0em",
                                  }}
                                >
                                  <h6 className="mb-1">
                                    <b>Company Address</b>
                                  </h6>
                                </div>
                                <div
                                  className="row g-3"
                                  style={{ marginTop: "1.7em" }}
                                >
                                  <div className="col-sm-12">
                                    <label
                                      className="form-label"
                                      htmlFor="multiStepsEmail"
                                    >
                                      Company Name
                                    </label>
                                    <input
                                      title=""
                                      required
                                      autoFocus={true}
                                      autoComplete="off"
                                      type="text"
                                      id="multiStepsFirstName"
                                      name="multiStepsFirstName"
                                      className="form-control"
                                      value={this.state.businessName}
                                      onChange={this.handleBusinessNameChange.bind(
                                        this
                                      )}
                                    />
                                  </div>
                                </div>
                                <div
                                  className="row g-3"
                                  style={{ marginTop: "0.5em" }}
                                >
                                  <div className="col-sm-12">
                                    <label
                                      className="form-label"
                                      htmlFor="multiStepsEmail"
                                    >
                                      Street Address
                                    </label>
                                    <input
                                      title=""
                                      required
                                      autoComplete="off"
                                      type="text"
                                      id="multiStepsFirstName"
                                      name="multiStepsFirstName"
                                      className="form-control"
                                      onChange={this.handleLine1Change.bind(
                                        this
                                      )}
                                      value={this.state.line}
                                    />
                                  </div>
                                </div>
                                <div
                                  className="row g-3"
                                  style={{ marginTop: "0.5em" }}
                                >
                                  <div className="col-md-6">
                                    <label
                                      className="form-label"
                                      htmlFor="collapsible-fullname"
                                    >
                                      City
                                    </label>
                                    <input
                                      title=""
                                      required
                                      autoComplete="off"
                                      type="text"
                                      id="multiStepsFirstName"
                                      name="multiStepsFirstName"
                                      className="form-control"
                                      value={this.state.city}
                                      onChange={this.handleCityChange.bind(
                                        this
                                      )}
                                    />
                                  </div>
                                  <div className="col-sm-6">
                                    <label
                                      className="form-label"
                                      htmlFor="multiStepsState"
                                    >
                                      State/Province/Region
                                    </label>

                                    <Autocomplete
                                      id="size-small-outlined"
                                      size="small"
                                      fullWidth
                                      disableClearable
                                      autoComplete="off"
                                      ListboxProps={{
                                        className: "custom-listbox",
                                      }}
                                      options={this.stateListArray}
                                      value={this.state.state}
                                      getOptionLabel={(option) =>
                                        option.namecode
                                      }
                                      defaultValue={this.state.state}
                                      onChange={(event, value) => {
                                        this.handleStateChange(value);
                                      }}
                                      inputprops={{
                                        style: {
                                          textTransform: "capitalize",
                                        },
                                      }}
                                      renderInput={(params) => (
                                        <TextField
                                          {...params}
                                          placeholder="Please Select"
                                          variant="outlined"
                                          size="small"
                                          className="textField"
                                          required
                                          title=""
                                          style={{ background: "#fff" }}
                                        />
                                      )}
                                    />
                                  </div>
                                </div>
                                <div
                                  className="row g-3"
                                  style={{ marginTop: "0.5em" }}
                                >
                                  <div className="col-md-6">
                                    <label
                                      className="form-label"
                                      htmlFor="collapsible-fullname"
                                    >
                                      Zip/Postal Code
                                    </label>
                                    <input
                                      title=""
                                      type="text"
                                      required
                                      autoComplete="off"
                                      id="multiStepsLastName"
                                      className="form-control"
                                      value={this.state.zipcode}
                                      onChange={this.handlePinCodeChange.bind(
                                        this
                                      )}
                                      inputprops={{ maxLength: 16 }}
                                      name="zipcode"
                                    />
                                    {this.state.zipCodeErrorMessageText && (
                                      <p
                                        style={{
                                          color: "red",
                                          fontSize: "13px",
                                        }}
                                      >
                                        {this.state.zipCodeErrorMessageText}
                                      </p>
                                    )}
                                  </div>
                                  <div className="col-sm-6">
                                    <label
                                      className="form-label"
                                      htmlFor="multiStepsEmail"
                                    >
                                      Country
                                    </label>

                                    <Autocomplete
                                      id="size-small-outlined"
                                      size="small"
                                      fullWidth
                                      disableClearable
                                      autoComplete="off"
                                      ListboxProps={{
                                        className: "custom-listbox",
                                      }}
                                      options={this.countryListArray}
                                      value={this.state.country}
                                      defaultValue={this.state.country}
                                      getOptionLabel={(option) =>
                                        option.namecode
                                      }
                                      onChange={(event, value) => {
                                        this.handleCountryChange(value);
                                      }}
                                      inputprops={{
                                        style: {
                                          textTransform: "capitalize",
                                        },
                                      }}
                                      renderInput={(params) => (
                                        <TextField
                                          {...params}
                                          placeholder="Please Select"
                                          variant="outlined"
                                          required
                                          title=""
                                          style={{ background: "#fff" }}
                                        />
                                      )}
                                    />
                                  </div>
                                </div>
                                <div
                                  className="row g-3"
                                  style={{ marginTop: "0.5em" }}
                                >
                                  <div className="col-md-6">
                                    {!this.state.otherCountryShow && (
                                      <>
                                        <label
                                          className="form-label"
                                          htmlFor="multiStepsEmail"
                                        >
                                          Timezone
                                        </label>
                                        <Autocomplete
                                          id="size-small-outlined"
                                          size="small"
                                          fullWidth
                                          disableClearable
                                          ListboxProps={{
                                            className: "custom-listbox",
                                          }}
                                          options={this.timeZoneListArray}
                                          value={this.state.timeZone}
                                          getOptionLabel={(option) => option.displayText}
                                          defaultValue={this.state.timeZone}
                                          onChange={(event, value) => {
                                            this.handleTimeZoneChange(value);
                                          }}
                                          inputprops={{
                                            style: {
                                              textTransform: "capitalize",
                                            },
                                          }}
                                          renderInput={(params) => (
                                            <TextField
                                              {...params}
                                              placeholder="Please Select"
                                              variant="outlined"
                                              size="small"
                                              className="textField"
                                              required
                                              title=""
                                              style={{ background: "#fff" }}
                                            />
                                          )}
                                        />
                                      </>
                                    )}
                                  </div>
                                  {this.state.otherCountryShow && (
                                    <div className="col-sm-5 mt-4 text-start align-self-start">
                                      <Button
                                        type="button"
                                        variant="contained"
                                        size="small"
                                        style={{
                                          background: "#37517e",
                                          color: "white",
                                          marginRight: "1rem",
                                          cursor: "pointer",
                                          borderRadius: "5px",
                                          textTransform: "capitalize",
                                          fontWeight: "600",
                                        }}
                                        onClick={(e) =>
                                          this.handalScheduleCallOpen(e)
                                        }
                                      >
                                        Schedule a call
                                      </Button>
                                    </div>
                                  )}
                                </div>
                              </div>
                            </div>
                            <div className="col-md-6">
                              <div className="card" id="giveBeeCard">
                                <div
                                  className="content-header"
                                  style={{
                                    // display: "flex",
                                    padding: "0.5em 0em",
                                  }}
                                >
                                  <h6 className="mb-1">
                                    <b>Company Details</b>
                                  </h6>
                                  <p
                                    style={{
                                      fontSize: "12px",
                                      marginBottom: "0px",
                                    }}
                                  >
                                    This information is provided to AT&amp;T and
                                    Verizon as part of your phone number
                                    verification application.
                                  </p>
                                  <p
                                    style={{
                                      fontSize: "12px",
                                      marginBottom: "0px",
                                    }}
                                  >
                                    The process usually takes about 4-5 days.
                                  </p>
                                </div>

                                <div className="row g-3">
                                  <div className="col-sm-6">
                                    <label
                                      className="form-label"
                                      htmlFor="multiStepsFirstName"
                                    >
                                      {Utils.equalsIgnoreCase(this.state.country?.name, "Canada") ? "Bus. Reg. # (BN)" : "Bus. Reg. # (EIN)"}
                                    </label>
                                    <input
                                      title=""
                                      autoComplete="off"
                                      required
                                      type="text"
                                      placeholder={Utils.equalsIgnoreCase(this.state.country?.name, "Canada") ? "12345 6789" : "12-123456"}
                                      id="multiStepsFirstName"
                                      name="multiStepsFirstName"
                                      className="form-control"
                                      maxLength={10}
                                      value={this.state.eIn}
                                      onChange={this.handleEinChange.bind(this)}
                                    />
                                    {this.state.einErrorMessageText && (
                                      <p
                                        style={{
                                          color: "red",
                                          fontSize: "13px",
                                        }}
                                      >
                                        {this.state.einErrorMessageText}
                                      </p>
                                    )}
                                  </div>
                                  <div className="col-sm-6">
                                    <label
                                      className="form-label"
                                      htmlFor="multiStepsLastName"
                                    >
                                      Company Type
                                    </label>

                                    <Autocomplete
                                      id="size-small-outlined"
                                      size="small"
                                      fullWidth
                                      disableClearable
                                      autoComplete="off"
                                      ListboxProps={{
                                        className: "custom-listbox",
                                      }}
                                      options={this.state.organizationTypeList}
                                      value={this.state.companyType}
                                      getOptionLabel={(option) => option.type}
                                      defaultValue={this.state.state}
                                      onChange={(event, value) => {
                                        this.handleCompanyTypeChange(value);
                                      }}
                                      inputprops={{
                                        style: { textTransform: "capitalize" },
                                      }}
                                      renderInput={(params) => (
                                        <TextField
                                          {...params}
                                          placeholder="Please Select"
                                          variant="outlined"
                                          size="small"
                                          className="textField"
                                          required
                                          title=""
                                          style={{ background: "#fff" }}
                                        />
                                      )}
                                    />
                                  </div>
                                </div>
                                <div
                                  className="row g-3"
                                  style={{ marginTop: "0.5em" }}
                                >
                                  <div className="col-sm-6">
                                    <label
                                      className="form-label"
                                      htmlFor="multiStepsEmail"
                                    >
                                      Business Name
                                      <InfoTooltip
                                        data="Please enter the exact legal business
                                      name, as registered with the EIN. E.g. ABC
                                      Company Inc. rather than ABC Company."
                                        style={{
                                          float: "right",
                                        }}
                                      />
                                    </label>
                                    <input
                                      title=""
                                      required
                                      autoComplete="off"
                                      type="text"
                                      value={this.state.businessName}
                                      onChange={this.handleBusinessNameChange.bind(
                                        this
                                      )}
                                      id="multiStepsFirstName"
                                      name="multiStepsFirstName"
                                      className="form-control"
                                      aria-label="john.doe"
                                    />
                                  </div>
                                  <div className="col-sm-6">
                                    <label
                                      className="form-label"
                                      htmlFor="multiStepsState"
                                    >
                                      Business Type
                                      <InfoTooltip
                                        data="What type of business is listed on your Tax ID listing?"
                                        style={{
                                          float: "right",
                                        }}
                                      />
                                    </label>

                                    <Autocomplete
                                      id="size-small-outlined"
                                      size="small"
                                      fullWidth
                                      disableClearable
                                      autoComplete="off"
                                      ListboxProps={{
                                        className: "custom-listbox",
                                      }}
                                      options={this.state.orgBusinessTypeList}
                                      value={this.state.orgBusinessType}
                                      getOptionLabel={(option) => option.type}
                                      defaultValue={this.state.orgBusinessType}
                                      onChange={(event, value) => {
                                        this.handleOrgBusinessTypeChange(value);
                                      }}
                                      inputprops={{
                                        style: { textTransform: "capitalize" },
                                      }}
                                      renderInput={(params) => (
                                        <TextField
                                          {...params}
                                          placeholder="Please Select"
                                          variant="outlined"
                                          size="small"
                                          className="textField"
                                          required
                                          title=""
                                          style={{ background: "#fff" }}
                                        />
                                      )}
                                    />
                                  </div>
                                </div>
                                <div
                                  className="row g-3"
                                  style={{ marginTop: "0.5em" }}
                                >
                                  <div className="col-sm-6">
                                    <label
                                      className="form-label"
                                      htmlFor="multiStepsState"
                                    >
                                      Business Industry
                                    </label>

                                    <Autocomplete
                                      id="size-small-outlined"
                                      size="small"
                                      autoComplete="off"
                                      fullWidth
                                      disableClearable
                                      ListboxProps={{
                                        className: "custom-listbox",
                                      }}
                                      options={this.state.businessIndustryList}
                                      value={this.state.businessIndustry}
                                      getOptionLabel={(option) =>
                                        option.industry
                                      }
                                      defaultValue={this.state.businessIndustry}
                                      onChange={(event, value) => {
                                        this.handleBusinessIndustryChange(
                                          value
                                        );
                                      }}
                                      inputprops={{
                                        style: { textTransform: "capitalize" },
                                      }}
                                      renderInput={(params) => (
                                        <TextField
                                          {...params}
                                          placeholder="Please Select"
                                          variant="outlined"
                                          size="small"
                                          className="textField"
                                          required
                                          title=""
                                          style={{ background: "#fff" }}
                                        />
                                      )}
                                    />
                                  </div>
                                  <div className="col-sm-6">
                                    <label
                                      className="form-label"
                                      htmlFor="multiStepsState"
                                    >
                                      Company Website URL
                                    </label>
                                    <input
                                      title=""
                                      required
                                      autoComplete="off"
                                      type="text"
                                      id="multiStepsName"
                                      className="form-control"
                                      name="multiStepsName"
                                      value={this.state.companyWebsite}
                                      onChange={this.handleCompanyWebsiteChange.bind(
                                        this
                                      )}
                                    />
                                    {this.state.cwUrlErrorMessage && (
                                      <p
                                        className="mb-0"
                                        style={{
                                          color: "red",
                                          fontSize: "13px",
                                        }}
                                      >
                                        {this.state.cwUrlErrorMessage}
                                      </p>
                                    )}
                                  </div>
                                </div>
                                <div
                                  className="row g-3"
                                  style={{ marginTop: "0.5em" }}
                                >
                                  <div className="col-sm-6">
                                    <label
                                      className="form-label"
                                      htmlFor="multiStepsEmail"
                                    >
                                      Business T&Cs URL
                                      <InfoTooltip
                                        data="Web address that contains your SMS Terms &
                                      Conditions"
                                        style={{
                                          float: "right",
                                        }}
                                      />
                                    </label>
                                    <input
                                      title=""
                                      required
                                      autoComplete="off"
                                      type="text"
                                      value={this.state.smsTAndCUrl}
                                      onChange={this.handleSmsTAndCUrlChange.bind(
                                        this
                                      )}
                                      id="multiStepsFirstName"
                                      name="multiStepsFirstName"
                                      className="form-control"
                                      aria-label="john.doe"
                                    />
                                    {this.state.tcUrlErrorMessage && (
                                      <p
                                        className="mb-0"
                                        style={{
                                          color: "red",
                                          fontSize: "13px",
                                        }}
                                      >
                                        {this.state.tcUrlErrorMessage}
                                      </p>
                                    )}
                                  </div>
                                  <div className="col-sm-6">
                                    <label
                                      className="form-label"
                                      htmlFor="multiStepsEmail"
                                    >
                                      Business Privacy Policy URL
                                    </label>
                                    <input
                                      title=""
                                      required
                                      autoComplete="off"
                                      type="text"
                                      value={this.state.smsPrivacyPolicyUrl}
                                      onChange={this.handleSmsPrivacyPolicyUrlChange.bind(
                                        this
                                      )}
                                      id="multiStepsFirstName"
                                      name="multiStepsFirstName"
                                      className="form-control"
                                      aria-label="john.doe"
                                    />
                                    {this.state.ppUrlErrorMessage && (
                                      <p
                                        style={{
                                          color: "red",
                                          fontSize: "13px",
                                        }}
                                      >
                                        {this.state.ppUrlErrorMessage}
                                      </p>
                                    )}
                                  </div>
                                </div>
                                <div
                                  className="row g-3"
                                  style={{ marginTop: "0.5em" }}
                                >
                                  <div className="col-sm-6">
                                    <label
                                      className="form-label"
                                      htmlFor="multiStepsState"
                                    >
                                      Integrated Payment Services
                                      <InfoTooltip
                                        data="Integrated Payment Services"
                                        style={{
                                          float: "right",
                                        }}
                                      />
                                    </label>
                                    <Autocomplete
                                      id="size-small-outlined"
                                      size="small"
                                      fullWidth
                                      disableClearable
                                      ListboxProps={{
                                        className: "custom-listbox",
                                      }}
                                      options={
                                        this.state.paymentServiceTypeList
                                      }
                                      value={this.state.paymentServicesType}
                                      getOptionLabel={(option) => option.type}
                                      defaultValue={
                                        this.state.paymentServicesType
                                      }
                                      onChange={(event, value) => {
                                        this.handlePaymentServicesTypeChange(
                                          value
                                        );
                                      }}
                                      inputprops={{
                                        style: {
                                          textTransform: "capitalize",
                                        },
                                      }}
                                      renderInput={(params) => (
                                        <TextField
                                          {...params}
                                          placeholder="Please Select"
                                          variant="outlined"
                                          size="small"
                                          className="textField"
                                          style={{ background: "#fff" }}
                                        />
                                      )}
                                    />
                                  </div>
                                  {this.state.payPalIdShow && (
                                    <div className="col-sm-6">
                                      <label
                                        className="form-label"
                                        htmlFor="multiStepsState"
                                      >
                                        PayPal ID
                                      </label>
                                      <input
                                        autoComplete="off"
                                        type="text"
                                        id="multiStepsName"
                                        className="form-control"
                                        name="multiStepsName"
                                        placeholder="John@yopmail.com"
                                        value={this.state.payPal}
                                        onChange={this.handlePayPalChange.bind(
                                          this
                                        )}
                                      />
                                    </div>
                                  )}
                                </div>
                                {this.state.showTaxExemptQue && (
                                  <>
                                    <div
                                      className="row g-3"
                                      style={{ marginTop: "0.5em" }}
                                    >
                                      <div className="col-sm-6">
                                        <label
                                          className="form-label"
                                          htmlFor="multiStepsState"
                                        >
                                          Is your non-profit tax-exempt?
                                        </label>{" "}
                                        <div
                                          className="row"
                                          style={{
                                            display: "inline-block",
                                            marginLeft: "0px",
                                          }}
                                        >
                                          <span
                                            style={{
                                              paddingRight: "2px",
                                              paddingLeft: "0px",
                                            }}
                                          >
                                            <input
                                              type="checkbox"
                                              style={{ height: "12px" }}
                                              required={
                                                this.state.taxExemptNo ===
                                                  false &&
                                                  this.state
                                                    .yesButUploadDocLater ===
                                                  false
                                                  ? "required"
                                                  : ""
                                              }
                                              value={this.state.taxExYes}
                                              onChange={(e) =>
                                                this.handleTaxExemptCheckedChange(
                                                  e
                                                )
                                              }
                                              checked={this.state.taxExYes}
                                            />
                                          </span>
                                          <span
                                            style={{
                                              padding: "0em",
                                              color: "#353538",
                                              fontSize: "0.9375rem",
                                              fontWeight: "400",
                                              lineHeight: "1.53",
                                              fontFamily:
                                                "Roboto, Helvetica, Arial, sans-serif",
                                            }}
                                          >
                                            Yes
                                          </span>
                                          <span style={{ paddingRight: "2px" }}>
                                            <input
                                              type="checkbox"
                                              style={{ height: "12px" }}
                                              required={
                                                this.state.taxExYes === false &&
                                                  this.state
                                                    .yesButUploadDocLater ===
                                                  false
                                                  ? "required"
                                                  : ""
                                              }
                                              value={this.state.taxExemptNo}
                                              onChange={(e) =>
                                                this.handleNoTaxExemptCheckedChange(
                                                  e
                                                )
                                              }
                                              checked={this.state.taxExemptNo}
                                            />
                                          </span>
                                          <span
                                            style={{
                                              padding: "0em",
                                              color: "#353538",
                                              fontSize: "0.9375rem",
                                              fontWeight: "400",
                                              lineHeight: "1.53",
                                              fontFamily:
                                                "Roboto, Helvetica, Arial, sans-serif",
                                            }}
                                          >
                                            No
                                          </span>

                                          <span style={{ paddingRight: "2px" }}>
                                            <input
                                              type="checkbox"
                                              style={{ height: "12px" }}
                                              required={
                                                this.state.taxExYes === false &&
                                                  this.state.taxExemptNo === false
                                                  ? "required"
                                                  : ""
                                              }
                                              value={
                                                this.state.yesButUploadDocLater
                                              }
                                              onChange={(e) =>
                                                this.handleYesButLaterTaxExemptCheckedChange(
                                                  e
                                                )
                                              }
                                              checked={
                                                this.state.yesButUploadDocLater
                                              }
                                            />
                                          </span>
                                          <span
                                            style={{
                                              padding: "0em",
                                              color: "#353538",
                                              fontSize: "0.9375rem",
                                              fontWeight: "400",
                                              lineHeight: "1.53",
                                              fontFamily:
                                                "Roboto, Helvetica, Arial, sans-serif",
                                            }}
                                          >
                                            Yes, but upload doc later
                                          </span>
                                        </div>
                                      </div>
                                    </div>
                                    <div
                                      className="row g-3"
                                      style={{ marginTop: "0em" }}
                                    >
                                      <div
                                        className="col-sm-6 align-items-center mt-1"
                                        style={{ display: "flex" }}
                                      >
                                        {this.state.uploadFileShow && (
                                          <>
                                            <div className="col-sm-12 text-start mt-1">
                                              {!this.state.showFileView ? (

                                                <div className="file-upload-wrapper">
                                                  <label
                                                    htmlFor="taxfile-upload"
                                                    className={`customImageVideo-file-upload ${this.state
                                                      .isTaxDocDragging
                                                      ? "dragging"
                                                      : ""
                                                      }`}
                                                    onDrop={
                                                      this.handleTaxDocDrop
                                                    }
                                                    onDragOver={
                                                      this.handleTaxDocDragOver
                                                    }
                                                    onDragLeave={
                                                      this.handleTaxDocDragLeave
                                                    }
                                                  >
                                                    <CloudUploadIcon className="upload-icon" />
                                                    <span className="upload-text">
                                                      Drop file here or{" "}
                                                      <span className="browse-link">Browse for file</span>
                                                    </span>

                                                    <input
                                                      type="file"
                                                      name="file"
                                                      id="taxfile-upload"
                                                      required
                                                      style={{ width: "240px" }}
                                                      onChange={this.handleTaxDocFileChange.bind(
                                                        this
                                                      )}
                                                    />
                                                  </label>

                                                  <small className="upload-note">
                                                    {this.state
                                                      .selectedTaxDocFile
                                                      ?.name === ""
                                                      ? "Choose file"
                                                      : this.state
                                                        .selectedTaxDocFile
                                                        ?.name}
                                                  </small>
                                                </div>
                                              ) : (
                                                <>
                                                  <span
                                                    onClick={(e) =>
                                                      this.onClickShowFile()
                                                    }
                                                    className="anchortag"
                                                  >
                                                    View tax document
                                                  </span>
                                                  <span className="ms-2">
                                                    <ClearIcon
                                                      className="logoDelete"
                                                      style={{
                                                        cursor: "pointer",
                                                        borderRadius: "50%",
                                                        border: "solid 2px",
                                                        color: "#697a8d",
                                                      }}
                                                      onClick={this.removeTaxExemptDocInBackend.bind(
                                                        this
                                                      )}
                                                    />
                                                  </span>
                                                </>
                                              )}
                                            </div>
                                            {/* <div className="col-sm-4 text-end mt-1">
                                              {!this.state.selectedTaxDocFile.name ||
                                              this.state.selectedTaxDocFile.name ===
                                                "" ? (
                                                <Button
                                                  id="ptsHollowButton"
                                                  type="button"
                                                  disabled={true}
                                                >
                                                  Upload
                                                </Button>
                                              ) : (
                                                <Button
                                                  id="ptsHollowButton"
                                                  type="button"
                                                  onClick={this.uploadOptInFile.bind(
                                                    this
                                                  )}
                                                >
                                                  Upload
                                                </Button>
                                              )}
                                            </div> */}
                                          </>
                                        )}
                                      </div>
                                      {this.state.uploadFileShow && (
                                        <span
                                          style={{
                                            fontSize: "12px",
                                            color: "blue",
                                          }}
                                        >
                                          {
                                            "(Please upload the appropriate document(s) proving your organization's tax-exempt status. (JPG or PDF format))"
                                          }
                                        </span>
                                      )}
                                    </div>
                                  </>
                                )}
                                <div
                                  className="row g-3"
                                  style={{ marginTop: "0.5em" }}
                                >
                                  {this.state.businessType
                                    ?.businessDomainName ===
                                    BUSINESS_DOMAIN.eventText && (
                                      <>
                                        <div className="col-md-6">
                                          {" "}
                                          <label
                                            htmlFor="exampleFormControlTextarea1"
                                            className="form-label"
                                          >
                                            Will some of your attendees be from
                                            outside the USA/Canada? &nbsp;
                                            <InfoTooltip
                                              data="Will you be sending texts to people in US/Can or another country?"
                                              pageId="registration"
                                              style={{
                                                float: "right",
                                              }}
                                            />
                                          </label>
                                          <Autocomplete
                                            size="small"
                                            fullWidth
                                            disableClearable
                                            options={[
                                              { label: "Yes", value: true },
                                              { label: "No", value: false },
                                            ]}
                                            getOptionLabel={(option) =>
                                              option.label
                                            }
                                            value={[
                                              { label: "Yes", value: true },
                                              { label: "No", value: false },
                                            ].find(
                                              (opt) =>
                                                opt.value ===
                                                this.state.isTextingCountries
                                            )}
                                            onChange={(event, newValue) => {
                                              this.setState({
                                                isTextingCountries:
                                                  newValue.value,
                                              });
                                            }}
                                            renderInput={(params) => (
                                              <TextField
                                                {...params}
                                                placeholder="Please Select"
                                                variant="outlined"
                                                size="small"
                                                className="textField"
                                                style={{ background: "#fff" }}
                                              />
                                            )}
                                          />
                                        </div>
                                        {this.state.isTextingCountries && (
                                          <div className="col-sm-6 align-self-end">
                                            <label
                                              className="form-label"
                                              htmlFor="multiStepsState"
                                            >
                                              Texting country
                                            </label>
                                            <div className="row textingCountry">
                                              <Multiselect
                                                onRemove={this.onRemoveTextingCountry.bind(
                                                  this
                                                )}
                                                onSelect={this.onSelectTextingCountry.bind(
                                                  this
                                                )}
                                                options={this.countryListArray}
                                                selectedValues={
                                                  this.state.textingCountryList
                                                }
                                                displayValue="name"
                                                showCheckbox
                                                placeholder={
                                                  this.state.textingCountryList
                                                    .length === 0
                                                    ? "None"
                                                    : this.state
                                                      .textingCountryList
                                                      .length > 1
                                                      ? `${this.state.textingCountryList.length} countries selected`
                                                      : `${this.state.textingCountryList.length} country selected`
                                                }
                                                hideSelectedList={true}
                                              />
                                            </div>
                                          </div>
                                        )}
                                      </>
                                    )}
                                </div>
                              </div>
                            </div>
                            {!["CustomMonthly", "CustomYearly", "CustomOnetime"].includes(
                              this.state.selectedPlan?.planType?.type
                            ) && (
                                <div classname="col-12">
                                  <div className="card " id="giveBeeCard">
                                    <div className="row">
                                      <div
                                        className="col-12 d-flex"
                                      // style={{ marginTop: "2em " }}
                                      >
                                        <span
                                          style={{
                                            color: "#162c50",
                                            marginTop: "3px",
                                          }}
                                        >
                                          <Checkbox
                                            style={{ color: "black" }}
                                            id="smsConsentCheckbox"
                                            checked={
                                              this.state.smsConsentPrivacyCheckbox
                                            }
                                            onChange={
                                              this
                                                .handleClickSmsConsentPrivacyCheckBox
                                            }
                                          />
                                        </span>
                                        <label
                                          className="ps-2 align-self-center"
                                          htmlFor="smsConsentCheckbox"
                                          style={{
                                            color: "#353538",
                                          }}
                                        >
                                          {(this.state.businessType?.businessDomainName === "EventText" && this.state.selectedPlan?.planType?.type === "Onetime") ? (
                                            <>
                                              I agree to add an SMS consent notice
                                              and a Privacy Policy (similar to the
                                              sample below) to the website:{" "}
                                              {this.state.companyWebsite ? (
                                                <a
                                                  className="anchortag"
                                                  target="_blank"
                                                  rel="noopener noreferrer"
                                                  href={
                                                    this.state.companyWebsite.includes("https://") ||
                                                      this.state.companyWebsite.includes("http://")
                                                      ? this.state.companyWebsite
                                                      : "http://" + this.state.companyWebsite
                                                  }
                                                >
                                                  {this.state.companyWebsite}
                                                </a>
                                              ) : (
                                                "—"
                                              )}
                                              .
                                            </>
                                          ) : (
                                            "In addition to adding an SMS opt-in checkbox and wording to our event registration form, I agree to add an SMS consent notice and a Privacy Policy (similar to the sample below) to our website."
                                          )}
                                        </label>
                                      </div>
                                      <div className="col-12 mt-2">
                                        <span
                                          style={{
                                            color: "#353538",
                                            fontWeight: "600",
                                            fontSize: "14px",
                                            paddingLeft: "4rem",
                                          }}
                                        >
                                          SMS Consent & Privacy
                                        </span>
                                        <p
                                          className="mb-0 mt-1"
                                          style={{
                                            color: "#353538",
                                            paddingLeft: "4rem",
                                          }}
                                        >
                                          {(this.state.businessType?.businessDomainName === "EventText" && this.state.selectedPlan?.planType?.type === "Onetime") ? (
                                            <>
                                              By providing your mobile number, you
                                              consent to receive SMS messages from{" "}
                                              {this.state.businessName}. Message
                                              frequency varies. Message and data
                                              rates may apply.
                                              <br />
                                              To opt out, reply "STOP" to any
                                              message. We do not share your mobile
                                              number with third parties or
                                              affiliates.
                                            </>
                                          ) : (
                                            <>
                                              By opting in for event texts, you
                                              consent to receive SMS messages from{" "}
                                              {this.state.businessName} for this
                                              event. Message frequency varies.
                                              Message and data rates may apply.
                                              <br />
                                              To opt out, reply "STOP" to any
                                              message. We do not share mobile
                                              contact information with third parties
                                              or affiliates for marketing or
                                              promotional purposes.
                                            </>
                                          )}
                                        </p>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              )}
                            <div
                              style={{
                                marginTop: "2em",
                                textAlign: "-webkit-right",
                              }}
                              className="col-12 d-flex justify-content-between"
                            >
                              <button
                                className="btn btn-label-secondary btn-prev"
                                style={{
                                  display: "flex",
                                  background: "gray",
                                  color: "#fff",
                                }}
                                onClick={this.handlePreviousPlanDetailsPage.bind(
                                  this
                                )}
                              >
                                <i className="bx bx-chevron-left bx-sm ms-sm-n2"></i>
                                <span className="align-middle d-sm-inline-block d-none">
                                  Back
                                </span>
                              </button>
                              {!this.state.otherCountryShow && (
                                <button
                                  type="submit"
                                  className="btn btn-primary btn-next"
                                  style={{ display: "flex" }}
                                  disabled={
                                    !this.state.smsConsentPrivacyCheckbox
                                  }
                                >
                                  <span className="align-middle d-sm-inline-block d-none me-sm-1 me-0">
                                    Next
                                  </span>
                                  <i className="bx bx-chevron-right bx-sm me-sm-n2"></i>
                                </button>
                              )}
                            </div>
                          </div>
                          {this.viewTaxDocument()}
                          {this.scheduleCall()}
                        </div>
                      </ValidatorForm>
                    )}
                    {this.state.activeAccountDetailsStep === true && (
                      <ValidatorForm
                        ref="form"
                        id="multiStepsForm"
                        onSubmit={(this.state.businessType?.businessDomainName === "EventText" && this.state.selectedPlan?.planType?.type === "Onetime") ?
                          this.handleNextEventDetailsPage.bind(
                            this
                          ) : this.handleNextIntegrationDetailsPage.bind(
                            this
                          )}
                      >
                        <div
                          id="personalInfoValidation"
                          className={
                            this.state.activeAccountDetailsStep === true
                              ? "content active dstepper-block fv-plugins-bootstrap5 fv-plugins-framework"
                              : "content"
                          }
                        >
                          <div
                            className="card "
                            id="userInfoCard"
                            style={{ height: "165px" }}
                          >
                            {" "}
                            <div className="content-header mb-3">
                              <h6 className="mb-1">
                                <b>User Information</b>
                              </h6>
                            </div>
                            <div
                              className="row g-3"
                              style={{ padding: "0.5em" }}
                            >
                              <div className="col-sm-4">
                                <label
                                  className="form-label"
                                  htmlFor="multiStepsUsername"
                                >
                                  User ID (email address)
                                </label>
                                <input
                                  title=""
                                  required
                                  autoFocus={this.state.userAutoFocus}
                                  autoComplete="off"
                                  type="email"
                                  id="multiStepsFirstName"
                                  name="multiStepsFirstName"
                                  className="form-control"
                                  value={this.state.email}
                                  onChange={this.handleEmailChange.bind(this)}
                                  onBlur={this.searchExistingEmail.bind(this)}
                                  aria-label="john.doe"
                                />
                              </div>

                              <div className="col-sm-4 form-password-toggle">
                                <label
                                  className="form-label"
                                  htmlFor="multiStepsPass"
                                >
                                  Password
                                  {this.state.passwordHelperText ? (
                                    <PasswordRequirementsTooltip
                                      error={error}
                                      open={passwordFocussed}
                                      style={{
                                        float: "right",
                                        marginTop: "-1em",
                                      }}
                                    />
                                  ) : (
                                    ""
                                  )}{" "}
                                </label>
                                <div className="input-group input-group-merge">
                                  <input
                                    type={this.state.showPassword ? "text" : "password"}
                                    id="password"
                                    name="password"
                                    className="form-control"
                                    aria-describedby="multiStepsPass2"
                                    onChange={this.handlePasswordChange.bind(
                                      this
                                    )}
                                    value={this.state.password}
                                    onFocus={this.toggleFocusNewPassword}
                                    onBlur={this.toggleFocusNewPassword}
                                    helperText={this.state.passwordHelperText}
                                    error={this.state.passwordHelperText !== ""}
                                  />
                                  <span
                                    className="input-group-text cursor-pointer"
                                    id="multiStepsPass2"
                                    onClick={this.handleClickShowPassword.bind(
                                      this
                                    )}
                                  >
                                    {this.state.showPassword ? (
                                      <VisibilityIcon />
                                    ) : (
                                      <VisibilityOffIcon />
                                    )}
                                  </span>
                                </div>
                              </div>
                              <div className="col-sm-4 form-password-toggle">
                                <label
                                  className="form-label"
                                  htmlFor="multiStepsConfirmPass"
                                >
                                  Confirm Password
                                </label>
                                <div className="input-group input-group-merge">
                                  <input
                                    id="confirmPassword"
                                    name="confirmPassword"
                                    className="form-control"
                                    aria-describedby="multiStepsConfirmPass2"
                                    value={this.state.confirmPassword}
                                    type={this.state.showConfirmPassword ? "text" : "password"}
                                    helperText={
                                      this.state.confirmPasswordHelperText
                                    }
                                    error={
                                      this.state.confirmPasswordHelperText !==
                                      ""
                                    }
                                    onChange={this.handlePasswordChange.bind(
                                      this
                                    )}
                                  />
                                  <span
                                    className="input-group-text cursor-pointer"
                                    id="multiStepsConfirmPass2"
                                    onClick={this.handleClickShowConfirmPassword.bind(
                                      this
                                    )}
                                  >
                                    {this.state.showConfirmPassword ? (
                                      <VisibilityIcon />
                                    ) : (
                                      <VisibilityOffIcon />
                                    )}
                                  </span>
                                </div>
                                {this.state.confirmPasswordHelperText && (
                                  <p style={{ color: "red", fontSize: "13px" }}>
                                    {this.state.confirmPasswordHelperText}
                                  </p>
                                )}
                              </div>
                            </div>
                          </div>
                          <div
                            className="card "
                            id="giveBeeCard"
                            style={{ marginTop: "1em", padding: "0.5em" }}
                          >
                            <div
                              className="content-header "
                              style={{ display: "flex" }}
                            >
                              <h6 className="mb-0 align-self-end">
                                <b>Contact Information </b>
                              </h6>
                              <InfoTooltip
                                data="For the person who will manage your GivBee campaigns."
                                style={{
                                  float: "right",
                                }}
                              />
                            </div>
                            <div
                              className="row g-3"
                              style={{ marginTop: "0em" }}
                            >
                              <div className="col-sm-4">
                                <label
                                  className="form-label"
                                  htmlFor="multiStepsFirstName"
                                >
                                  First Name
                                </label>
                                <input
                                  title=""
                                  required
                                  autoComplete="off"
                                  type="text"
                                  id="multiStepsFirstName"
                                  name="multiStepsFirstName"
                                  className="form-control"
                                  value={this.state.firstName}
                                  onChange={this.handleFirstNameChange.bind(
                                    this
                                  )}
                                />
                              </div>
                              <div className="col-sm-4">
                                <label
                                  className="form-label"
                                  htmlFor="multiStepsLastName"
                                >
                                  Last Name
                                </label>
                                <input
                                  title=""
                                  required
                                  autoComplete="off"
                                  type="text"
                                  value={this.state.lastName}
                                  onChange={this.handleLastNameChange.bind(
                                    this
                                  )}
                                  id="multiStepsFirstName"
                                  name="multiStepsFirstName"
                                  className="form-control"
                                />
                              </div>
                              <div className="col-sm-4">
                                <label
                                  className="form-label"
                                  htmlFor="multiStepsEmail"
                                >
                                  Email Address
                                </label>
                                <input
                                  title=""
                                  required
                                  disabled
                                  autoComplete="off"
                                  type="email"
                                  value={this.state.email}
                                  onChange={this.handleEmailChange.bind(this)}
                                  id="multiStepsFirstName"
                                  name="multiStepsFirstName"
                                  className="form-control"
                                  aria-label="john.doe"
                                />
                              </div>
                              <div className="col-sm-4">
                                <label
                                  className="form-label"
                                  htmlFor="multiStepsEmail"
                                >
                                  Job Title
                                </label>
                                <input
                                  title=""
                                  required
                                  type="text"
                                  autoComplete="off"
                                  id="multiStepsFirstName"
                                  name="multiStepsFirstName"
                                  className="form-control"
                                  value={this.state.jobTitle}
                                  onChange={this.handleJobTitleChange.bind(
                                    this
                                  )}
                                />
                              </div>

                              <div className="col-sm-4">
                                <label
                                  className="form-label "
                                  htmlFor="collapsible-phone"
                                >
                                  Mobile Phone - <b style={{ fontSize: "12px", color: "red" }}>IMPORTANT! MUST BE USER'S PRIMARY MOBILE</b>
                                </label>
                                {enableCountryCode ?
                                  <span className="d-flex">
                                    <PhoneInput
                                      country={this.state.country?.code?.toLowerCase()}
                                      onlyCountries={["us", "ca", "au", "in"]}
                                      value={this.state.countryCode}
                                      onChange={(
                                        phone,
                                        country,
                                        e,
                                        formattedValue
                                      ) => {
                                        this.handleCountryCodeChange(
                                          phone,
                                          country,
                                          e,
                                          formattedValue
                                        );
                                      }}
                                      autoFormat
                                      countryCodeEditable={false}
                                      disableCountryGuess={false}
                                      enableSearch={true}
                                      alwaysDefaultMask={true}
                                    />
                                    <input
                                      title=""
                                      required
                                      type="text"
                                      autoComplete="off"
                                      name="multiStepsFirstName"
                                      style={{ borderRadius: "0px 5px 5px 0px" }}
                                      className="form-control"
                                      value={this.state.phone}
                                      onChange={this.handlePhoneChange.bind(this)}
                                      validators={["required"]}
                                      errormessages={["This field is required"]}
                                      onInvalid={(e) => {
                                        e.target.setCustomValidity(
                                          "Mobile number required"
                                        );
                                      }}
                                      onInput={(e) => {
                                        e.target.setCustomValidity("");
                                      }}
                                    />
                                  </span>
                                  : <input
                                    title=""
                                    required
                                    type="text"
                                    autoComplete="off"
                                    name="multiStepsFirstName"
                                    className="form-control"
                                    value={this.state.phone}
                                    onChange={this.handlePhoneChange.bind(this)}
                                    validators={["required"]}
                                    errormessages={["This field is required"]}
                                    onInvalid={(e) => {
                                      e.target.setCustomValidity(
                                        "Mobile number required"
                                      );
                                    }}
                                    onInput={(e) => {
                                      e.target.setCustomValidity("");
                                    }}
                                  />
                                }
                                {this.state.mobilephoneHelperText && (
                                  <p style={{ color: "red", fontSize: "13px" }}>
                                    {this.state.mobilephoneHelperText}
                                  </p>
                                )}
                              </div>
                              <div className="col-sm-4">
                                <label
                                  className="form-label "
                                  htmlFor="collapsible-officephone"
                                >
                                  Office Phone
                                </label>
                                {enableCountryCode ?
                                  <span className="d-flex">
                                    <PhoneInput
                                      country={this.state.country?.code?.toLowerCase()}
                                      onlyCountries={["us", "ca", "au", "in"]}
                                      value={this.state.officeCountryCode}
                                      onChange={(
                                        phone,
                                        country,
                                        e,
                                        formattedValue
                                      ) => {
                                        this.handleOfficeCountryChange(
                                          phone,
                                          country,
                                          e,
                                          formattedValue
                                        );
                                      }}
                                      autoFormat
                                      countryCodeEditable={false}
                                      disableCountryGuess={false}
                                      enableSearch={true}
                                      alwaysDefaultMask={true}
                                    />
                                    <input
                                      title=""
                                      required
                                      type="text"
                                      autoComplete="off"
                                      id="multiStepsFirstName"
                                      name="multiStepsFirstName"
                                      style={{ borderRadius: "0px 5px 5px 0px" }}
                                      className="form-control"
                                      value={this.state.officePhone}
                                      onChange={this.handleOfficePhoneChange.bind(
                                        this
                                      )}
                                      validators={["required"]}
                                      errormessages={["This field is required"]}
                                    // onInvalid={(e) => {
                                    //   e.target.setCustomValidity(
                                    //     "Mobile number required"
                                    //   );
                                    // }}
                                    />
                                  </span>
                                  :
                                  <input
                                    title=""
                                    required
                                    type="text"
                                    autoComplete="off"
                                    id="multiStepsFirstName"
                                    name="multiStepsFirstName"
                                    className="form-control"
                                    value={this.state.officePhone}
                                    onChange={this.handleOfficePhoneChange.bind(
                                      this
                                    )}
                                    validators={["required"]}
                                    errormessages={["This field is required"]}
                                  />
                                }
                                {this.state.officephoneHelperText && (
                                  <p style={{ color: "red", fontSize: "13px" }}>
                                    {this.state.officephoneHelperText}
                                  </p>
                                )}
                              </div>
                            </div>
                          </div>
                          <div
                            className="col-12 d-flex justify-content-between"
                            style={{ marginTop: "2em" }}
                          >
                            <button
                              className="btn btn-label-secondary btn-prev"
                              style={{
                                display: "flex",
                                background: "gray",
                                color: "#fff",
                              }}
                              onClick={this.handlePreviousCompanyDetailsPage.bind(
                                this
                              )}
                            >
                              <i className="bx bx-chevron-left bx-sm ms-sm-n2"></i>
                              <span className="align-middle d-sm-inline-block d-none">
                                Back
                              </span>
                            </button>
                            <button
                              type="submit"
                              className="btn btn-primary btn-next"
                              style={{ display: "flex" }}
                            >
                              <span className="align-middle d-sm-inline-block d-none me-sm-1 me-0">
                                Next
                              </span>
                              <i className="bx bx-chevron-right bx-sm me-sm-n2"></i>
                            </button>
                          </div>{" "}
                        </div>
                      </ValidatorForm>
                    )}
                    {(this.state.activeEventDetailsStep === true && this.state.businessType?.businessDomainName === "EventText" && this.state.selectedPlan?.planType?.type === "Onetime") && (
                      <ValidatorForm
                        ref="form"
                        id="multiStepsForm"
                        onSubmit={this.handleNextIntegrationDetailsPage.bind(
                          this
                        )}
                      >
                        <div
                          id="personalInfoValidation"
                          className={
                            this.state.activeEventDetailsStep === true
                              ? "content active dstepper-block fv-plugins-bootstrap5 fv-plugins-framework"
                              : "content"
                          }
                        >
                          <div className="row">
                            <div className="col-md-12">
                              <div className="card " id="giveBeeCard">
                                <div className="row d-flex">
                                  <div className="col-md-6">
                                    <div
                                      className="card-header d-flex align-items-center justify-content-between p-4"
                                      id="assetCardHeader"
                                    >
                                      <div className="col-md-12">
                                        <span
                                          className="fw-bold"
                                          style={{ color: "#06669a", fontSize: "18px" }}
                                        >
                                          Please provide basic details about your event.
                                        </span>
                                      </div>
                                    </div>
                                    <div className="card-body">
                                      <div className="row">
                                        <div className="col-md-12">
                                          <div className="row">
                                            <div className="col-md-6" id="assetFormLabel">
                                              <label
                                                className="form-label "
                                                htmlFor="collapsible-firstname"
                                                style={{ marginBottom: "0.15rem" }}
                                              >
                                                Event Name*
                                              </label>
                                              <input
                                                title=""
                                                required
                                                type="text"
                                                autoComplete="off"
                                                id="multiStepsFirstName"
                                                name="multiStepsFirstName"
                                                className="form-control"
                                                value={this.state.eventName}
                                                onChange={this.handleEventNameChange.bind(this)}
                                                validators={["required"]}
                                                errormessages={["This field is required"]}
                                              />
                                            </div>
                                            <div className="col-md-6" id="assetFormLabel">
                                              <label
                                                className="MuiAutocomplete-label form-label "
                                                htmlFor="collapsible-firstname"
                                              >
                                                Event Type*
                                              </label>

                                              <Autocomplete
                                                title=""
                                                required
                                                id="size-small-outlined"
                                                size="small"
                                                fullWidth
                                                disableClearable
                                                autoComplete="off"
                                                ListboxProps={{
                                                  className: "custom-listbox",
                                                }}
                                                options={this.state.eventTypes}
                                                value={this.state.eventType}
                                                getOptionLabel={(option) => option.type}
                                                defaultValue={this.state.eventType}
                                                onChange={(event, value) => {
                                                  this.handleEventTypeChange(value);
                                                }}
                                                inputprops={{
                                                  style: { textTransform: "capitalize" },
                                                }}
                                                renderInput={(params) => (
                                                  <TextField
                                                    {...params}
                                                    placeholder="Please Select"
                                                    variant="outlined"
                                                    size="small"
                                                    style={{ background: "#fff" }}
                                                  />
                                                )}
                                              />
                                            </div>
                                          </div>
                                          <div className="row mt-3 datePickerHelperText">
                                            <div className="col-md-6" id="assetFormLabel">
                                              <label
                                                className="form-label MuiAutocomplete-label"
                                                htmlFor="collapsible-email"
                                              >
                                                Start Date*
                                                <span
                                                  className="ms-1"
                                                  style={{
                                                    fontSize: "12px",
                                                    fontWeight: "400",
                                                  }}
                                                >
                                                  (Texting First Day)
                                                </span>
                                              </label>
                                              <MuiPickersUtilsProvider utils={DateFnsUtils}>
                                                <ThemeProvider theme={materialTheme}>
                                                  <DatePicker
                                                    value={this.state.startDate}
                                                    variant="outlined"
                                                    fullWidth
                                                    size="small"
                                                    inputVariant="outlined"
                                                    // timeinputlabel="Time:"
                                                    minDate={subDays(new Date(), 0)}
                                                    format="MM/dd/yyyy"
                                                    style={{ background: "#fff" }}
                                                    onChange={this.handleStartDateChange.bind(
                                                      this
                                                    )}
                                                    helperText={
                                                      this.state.errorMassage
                                                        ? "Start Date is Required"
                                                        : ""
                                                    }
                                                    error={this.state.errorMassage}
                                                    InputProps={{
                                                      readOnly: true,
                                                      endAdornment: (
                                                        <InputAdornment position="end">
                                                          <IconButton>
                                                            <span className="picker-icon" style={{ fontSize: "22px" }}>📅</span>
                                                          </IconButton>
                                                        </InputAdornment>
                                                      ),
                                                    }}
                                                  />
                                                </ThemeProvider>
                                              </MuiPickersUtilsProvider>
                                            </div>
                                            <div className="col-md-6" id="assetFormLabel">
                                              <label
                                                className="form-label MuiAutocomplete-label"
                                                htmlFor="collapsible-email"
                                              >
                                                End Date*
                                                <span
                                                  className="ms-1"
                                                  style={{
                                                    fontSize: "12px",
                                                    fontWeight: "400",
                                                  }}
                                                >
                                                  (Texting end from this day)
                                                </span>
                                              </label>
                                              <MuiPickersUtilsProvider utils={DateFnsUtils}>
                                                <ThemeProvider theme={materialTheme}>
                                                  <DatePicker
                                                    value={this.state.endDate}
                                                    variant="outlined"
                                                    fullWidth
                                                    size="small"
                                                    inputVariant="outlined"
                                                    minDate={subDays(new Date(), 0)}
                                                    format="MM/dd/yyyy"
                                                    style={{ background: "#fff" }}
                                                    onChange={this.handleEndDateChange.bind(
                                                      this
                                                    )}
                                                    helperText={
                                                      this.state.endDateErrorMassage
                                                        ? "End Date is Required"
                                                        : ""
                                                    }
                                                    error={this.state.endDateErrorMassage}
                                                    InputProps={{
                                                      readOnly: true,
                                                      endAdornment: (
                                                        <InputAdornment position="end">
                                                          <IconButton>
                                                            <span className="picker-icon" style={{ fontSize: "22px" }}>📅</span>
                                                          </IconButton>
                                                        </InputAdornment>
                                                      ),
                                                    }}
                                                  />
                                                </ThemeProvider>
                                              </MuiPickersUtilsProvider>
                                              {this.state.eventDateErrorMassage ? (
                                                <lable className="errorMassageShow">
                                                  End Date should be after Start Date
                                                </lable>
                                              ) : (
                                                ""
                                              )}
                                            </div>
                                          </div>
                                          {this.state.isDatechangeRequested && (
                                            <>
                                              {this.header?.isAp ? (
                                                <div className="row mt-3 datePickerHelperText">
                                                  <div
                                                    className="col-md-6 align-self-center"
                                                    id="assetFormLabel"
                                                  >
                                                    <div className="row">
                                                      <label
                                                        className="col-sm-5 form-label pe-0"
                                                        htmlFor="collapsible-email"
                                                      >
                                                        New Start Date
                                                      </label>
                                                      <div className="col-sm-7 MuiInputBase-root">
                                                        {Utils.ptsDateFormat(
                                                          this.state.requestedStartDate
                                                        )}
                                                      </div>
                                                    </div>
                                                    <div className="row">
                                                      <label
                                                        className="col-sm-5 form-label pe-0"
                                                        htmlFor="collapsible-jotitle"
                                                      >
                                                        New End Date
                                                      </label>
                                                      <div className="col-sm-7 MuiInputBase-root">
                                                        {Utils.ptsDateFormat(
                                                          this.state.requestedEndDate
                                                        )}
                                                      </div>
                                                    </div>
                                                  </div>
                                                  <div
                                                    className="col-md-6 align-self-center"
                                                    id="assetFormLabel"
                                                  >
                                                    <div className="row">
                                                      <div className="col-sm-12">
                                                        <Button
                                                          type="button"
                                                          variant="contained"
                                                          id="ptsButton"
                                                          style={{
                                                            background: "green",
                                                            color: "#fff",
                                                            marginRight: "1rem",
                                                            fontWeight: "bold",
                                                            textTransform: "capitalize",
                                                            padding: "2px 10px",
                                                            "&:hover": {
                                                              backgroundColor: "#1a3a5c", // Darker shade on hover
                                                            },
                                                          }}
                                                          onClick={this.approveDateChangeToBackend.bind(
                                                            this
                                                          )}
                                                        >
                                                          Approve
                                                        </Button>
                                                        <Button
                                                          type="button"
                                                          variant="contained"
                                                          id="ptsButton"
                                                          // startIcon={<CloseIcon />}
                                                          onClick={this.rejectDateChangeToBackend.bind(
                                                            this
                                                          )}
                                                        >
                                                          Deny
                                                        </Button>
                                                      </div>
                                                    </div>
                                                  </div>
                                                </div>
                                              ) : (
                                                <div className="row mt-3 datePickerHelperText">
                                                  <span style={{ color: "red" }}>
                                                    Date Change Requested.
                                                  </span>
                                                </div>
                                              )}
                                            </>
                                          )}
                                          {/* <div className="row mt-3">
                                              <div className="col-sm-12">
                                                <label className="form-label" htmlFor="multiStepsEmail">
                                                  City
                                                </label>
                                                <input
                                                  autoComplete="off"
                                                  type="text"
                                                  id="multiStepsFirstName"
                                                  name="multiStepsFirstName"
                                                  className="form-control"
                                                  onChange={this.handleLocationChange.bind(this)}
                                                  value={this.state.location}
                                                />
                                              </div>
                                            </div> */}
                                          <div className="row mt-3">
                                            <div className="col-md-6" id="assetFormLabel">
                                              <label
                                                className="MuiAutocomplete-label form-label"
                                                htmlFor="collapsible-fullname"
                                              >
                                                Country
                                              </label>
                                              <Autocomplete
                                                id="size-small-outlined"
                                                size="small"
                                                fullWidth
                                                disableClearable
                                                autoComplete="off"
                                                ListboxProps={{
                                                  className: "custom-listbox",
                                                }}
                                                options={this.countryListArray}
                                                value={this.state.eventCountry}
                                                defaultValue={this.state.select}
                                                getOptionLabel={(option) => option.namecode}
                                                onChange={(event, value) => {
                                                  this.handleEventCountryChange(value);
                                                }}
                                                inputprops={{
                                                  style: { textTransform: "capitalize" },
                                                }}
                                                renderInput={(params) => (
                                                  <TextField
                                                    {...params}
                                                    placeholder="Please Select"
                                                    variant="outlined"
                                                    size="small"
                                                    style={{ background: "#fff" }}
                                                  />
                                                )}
                                              />
                                            </div>
                                            <div className="col-md-6" id="assetFormLabel">
                                              <label
                                                className="MuiAutocomplete-label form-label"
                                                htmlFor="multiStepsState"
                                              >
                                                State
                                              </label>
                                              <Autocomplete
                                                id="size-small-outlined"
                                                size="small"
                                                fullWidth
                                                disableClearable
                                                ListboxProps={{
                                                  className: "custom-listbox",
                                                }}
                                                disabled={this.state.eventCountry === null}
                                                options={this.stateListArray}
                                                value={this.state.eventState}
                                                getOptionLabel={(option) => option.namecode}
                                                defaultValue={this.state.eventState}
                                                onChange={(event, value) => {
                                                  this.handleEventStateChange(value);
                                                }}
                                                inputprops={{
                                                  style: { textTransform: "capitalize" },
                                                }}
                                                renderInput={(params) => (
                                                  <TextField
                                                    {...params}
                                                    placeholder="Please Select"
                                                    variant="outlined"
                                                    size="small"
                                                    style={{ background: "#fff" }}
                                                  />
                                                )}
                                              />
                                            </div>
                                          </div>
                                          <div className="row mt-3">
                                            <div className="col-md-6">
                                              <label
                                                className="MuiAutocomplete-label form-label"
                                                htmlFor="multiStepsEmail"
                                              >
                                                Timezone*
                                              </label>
                                              <Autocomplete
                                                id="size-small-outlined"
                                                size="small"
                                                fullWidth
                                                disableClearable
                                                ListboxProps={{
                                                  className: "custom-listbox",
                                                }}
                                                options={this.timeZoneListArray}
                                                value={this.state.eventTimeZone}
                                                getOptionLabel={(option) =>
                                                  option.name + " (" + option.abbreviation + ")"
                                                }
                                                defaultValue={this.state.eventTimeZone}
                                                onChange={(event, value) => {
                                                  this.handleEventTimeZoneChange(value);
                                                }}
                                                inputprops={{
                                                  style: { textTransform: "capitalize" },
                                                }}
                                                renderInput={(params) => (
                                                  <TextField
                                                    {...params}
                                                    title=""
                                                    required
                                                    placeholder="Please Select"
                                                    variant="outlined"
                                                    size="small"
                                                    style={{ background: "#fff" }}
                                                  />
                                                )}
                                              />
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="col-md-6">
                                    <div
                                      className="card-header d-flex align-items-center justify-content-between p-4"
                                      id="assetCardHeader"
                                    >
                                      <div className="col-md-12">
                                        <FormControlLabel
                                          style={{
                                            color: "#353538",
                                            margin: "0",
                                            padding: "0",
                                            height: "15px",
                                          }}
                                          control={
                                            <Checkbox
                                              variant="outlined"
                                              id="isAsset"
                                              checked={this.state.isConnectToCvent}
                                              value={this.state.isConnectToCvent}
                                              onChange={this.handleIsConnectToCventChange.bind(
                                                this
                                              )}
                                              style={{
                                                background: "none",
                                                marginBottom: "2px",
                                              }}
                                            />
                                          }
                                          label={
                                            <span className="form-label">
                                              Collect text opt-in during Cvent registration.
                                            </span>
                                          }
                                          labelPlacement="end"
                                        />
                                      </div>
                                    </div>
                                    <div className="card-body">
                                      <div className="row">
                                        <div className="col-md-12">
                                          {this.state.isConnectToCvent && (
                                            <>
                                              <div className="row">
                                                <div className="col-md-6" id="assetFormLabel">
                                                  <label
                                                    className="form-label "
                                                    htmlFor="collapsible-firstname"
                                                    style={{ marginBottom: "0.15rem" }}
                                                  >
                                                    Enter the Cvent Event Code
                                                  </label>
                                                  <input
                                                    type="text"
                                                    autoComplete="off"
                                                    id="multiStepsFirstName"
                                                    name="multiStepsFirstName"
                                                    className="form-control"
                                                    value={this.state.ceventCode}
                                                    onChange={this.handleCeventCodeChange.bind(
                                                      this
                                                    )}
                                                    validators={["required"]}
                                                    errormessages={["This field is required"]}
                                                  />
                                                </div>
                                              </div>
                                              <div className="row mt-3">
                                                <div className="col-md-6" id="assetFormLabel">
                                                  <label
                                                    className="MuiAutocomplete-label form-label "
                                                    htmlFor="collapsible-firstname"
                                                    style={{ paddingBottom: "2.5px" }}
                                                  >
                                                    What Cvent data do you want to pull over?
                                                  </label>

                                                  <Autocomplete
                                                    id="size-small-outlined"
                                                    size="small"
                                                    fullWidth
                                                    disableClearable
                                                    autoComplete="off"
                                                    ListboxProps={{
                                                      className: "custom-listbox",
                                                    }}
                                                    options={this.state.cventDataCarryoverTypes}
                                                    value={this.state.ceventCarryover}
                                                    getOptionLabel={(option) => option.type}
                                                    defaultValue={this.state.ceventCarryover}
                                                    onChange={(event, value) => {
                                                      this.handleCeventCarryoverChange(value);
                                                    }}
                                                    inputprops={{
                                                      style: { textTransform: "capitalize" },
                                                    }}
                                                    renderInput={(params) => (
                                                      <TextField
                                                        {...params}
                                                        placeholder="Please Select"
                                                        variant="outlined"
                                                        size="small"
                                                        style={{ background: "#fff" }}
                                                      />
                                                    )}
                                                  />
                                                </div>
                                              </div>
                                              <div className="row mt-3">
                                                <div className="col-md-6" id="assetFormLabel">
                                                  <label
                                                    className="form-label "
                                                    htmlFor="collapsible-firstname"
                                                  >
                                                    If you want to send a confirmation text msg
                                                    with each new registration, enter it here:
                                                  </label>
                                                  <textarea
                                                    value={
                                                      this.state.registrationConfirmationText
                                                    }
                                                    onChange={this.handleEventRegConfirmationTextChange.bind(
                                                      this
                                                    )}
                                                    className="form-control"
                                                    id="exampleFormControlTextarea1"
                                                    rows="2"
                                                  />
                                                </div>
                                              </div>
                                            </>
                                          )}
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div
                            className="col-12 d-flex justify-content-between"
                            style={{ marginTop: "2em" }}
                          >
                            <button
                              className="btn btn-label-secondary btn-prev"
                              style={{
                                display: "flex",
                                background: "gray",
                                color: "#fff",
                              }}
                              onClick={this.handlePreviousUseCaseDetailsPage.bind(
                                this
                              )}
                            >
                              <i className="bx bx-chevron-left bx-sm ms-sm-n2"></i>
                              <span className="align-middle d-sm-inline-block d-none">
                                Back
                              </span>
                            </button>
                            <button
                              type="submit"
                              className="btn btn-primary btn-next"
                              style={{ display: "flex" }}
                            >
                              <span className="align-middle d-sm-inline-block d-none me-sm-1 me-0">
                                Next
                              </span>
                              <i className="bx bx-chevron-right bx-sm me-sm-n2"></i>
                            </button>
                          </div>{" "}
                        </div>
                      </ValidatorForm>
                    )}
                    {this.state.activeIntegrationStep === true && (
                      <>
                        <ValidatorForm
                          ref="form"
                          id="multiStepsForm"
                          onSubmit={this.createAccountInBackend.bind(this)}
                        >
                          <div
                            id="integrationValidation"
                            className={
                              this.state.activeIntegrationStep === true
                                ? "content active dstepper-block fv-plugins-bootstrap5 fv-plugins-framework"
                                : '"content'
                            }
                          >
                            <div className="row">
                              <div className="col-md-12">
                                <div
                                  className="card "
                                  id="giveBeeCard"
                                  style={{ height: "325px" }}
                                >
                                  {" "}
                                  <div className="content-header mb-3">
                                    <h6 className="mb-1">
                                      <b>Integration</b>
                                    </h6>
                                  </div>
                                  <div className="row p-4 d-flex">
                                    <div className="col-md-3">
                                      <div className="row mt-4">
                                        <div className="col-md-12 text-center">
                                          {Utils.equalsIgnoreCase(
                                            this.state.crmIntegration?.name,
                                            "None"
                                          ) && (
                                              <img
                                                src={CrmIntegration}
                                                className="blackbaudLogo"
                                                alt="Crm Integration logo"
                                              />
                                            )}
                                          {this.state.neonOrgApiKeyShow && (
                                            <img
                                              src={NeonCrmLogo}
                                              className="neonCrmLogo"
                                              alt="Neon CRM logo"
                                            />
                                          )}
                                          {this.state.blackBaudRefreshShow && (
                                            <img
                                              src={BlackbaudLogo}
                                              className="blackbaudLogo"
                                              alt="Blackbaud logo"
                                            />
                                          )}
                                          {this.state.CEventShow && (
                                            <img
                                              src={CventLogo}
                                              className="neonCrmLogo"
                                              alt="Cvent logo"
                                            />
                                          )}
                                        </div>
                                      </div>
                                    </div>
                                    <div className="col-md-5">
                                      <div className="row g-3">
                                        <div className="col-sm-9">
                                          <label
                                            className="form-label"
                                            htmlFor="multiStepsState"
                                          >
                                            CRM integration
                                          </label>
                                          <Autocomplete
                                            id="size-small-outlined"
                                            size="small"
                                            fullWidth
                                            disableClearable
                                            ListboxProps={{
                                              className: "custom-listbox",
                                            }}
                                            options={
                                              this.state.crmIntegrationList
                                            }
                                            value={this.state.crmIntegration}
                                            getOptionLabel={(option) =>
                                              option.description
                                            }
                                            defaultValue={
                                              this.state.crmIntegration
                                            }
                                            onChange={(event, value) => {
                                              this.handleCrmIntegrationChange(
                                                value
                                              );
                                            }}
                                            inputprops={{
                                              style: {
                                                textTransform: "capitalize",
                                              },
                                            }}
                                            renderInput={(params) => (
                                              <TextField
                                                {...params}
                                                placeholder="Please Select"
                                                variant="outlined"
                                                size="small"
                                                className="textField"
                                                style={{ background: "#fff" }}
                                              />
                                            )}
                                          />
                                        </div>
                                      </div>
                                      {this.state.neonOrgApiKeyShow && (
                                        <>
                                          <div className="row mt-3">
                                            <div className="col-sm-9">
                                              <label
                                                className="form-label w-100"
                                                htmlFor="multiStepsCard"
                                              >
                                                Neon Org ID
                                              </label>
                                              <div className="input-group input-group-merge">
                                                <input
                                                  title=""
                                                  autoComplete="off"
                                                  required
                                                  id="multiStepsCard"
                                                  className="form-control multi-steps-card"
                                                  name="multiStepsCard"
                                                  type="text"
                                                  aria-describedby="multiStepsCardImg"
                                                  value={this.state.neonOrgId}
                                                  onChange={this.handleNenOrgIdChange.bind(
                                                    this
                                                  )}
                                                />
                                              </div>
                                            </div>
                                          </div>
                                          <div className="row mt-3">
                                            <div className="col-sm-9">
                                              <label
                                                className="form-label w-100"
                                                htmlFor="multiStepsCard"
                                              >
                                                Neon API Key
                                              </label>
                                              <div className="input-group input-group-merge">
                                                <input
                                                  title=""
                                                  autoComplete="off"
                                                  required
                                                  id="multiStepsCard"
                                                  className="form-control multi-steps-card"
                                                  name="multiStepsCard"
                                                  type="text"
                                                  aria-describedby="multiStepsCardImg"
                                                  value={
                                                    this.state.neonOrgApiKey
                                                  }
                                                  onChange={this.handleNeonOrgApiKeyChange.bind(
                                                    this
                                                  )}
                                                />
                                              </div>
                                            </div>
                                            <div
                                              className="col-sm-4"
                                              style={{
                                                textAlign: "left",
                                                marginTop: "auto",
                                              }}
                                            ></div>
                                          </div>
                                        </>
                                      )}
                                      {this.state.blackBaudRefreshShow && (
                                        <>
                                          <div
                                            className="col-sm-12 mt-2"
                                            id="givbeeText"
                                          >
                                            <div className="row align-items-end">
                                              <p
                                                className="mb-0"
                                                style={{ paddingRight: "42px" }}
                                              >
                                                GivBee's Blackbaud integration
                                                provides a connection to RE NXT
                                                and an option to integrate BBMS
                                                payments.{" "}
                                                <span
                                                  className="anchortag"
                                                  onClick={(e) =>
                                                    this.handleHelpContentsOpen(
                                                      e
                                                    )
                                                  }
                                                >
                                                  Click here
                                                </span>{" "}
                                                for more information.
                                              </p>
                                            </div>
                                          </div>
                                        </>
                                      )}
                                      {this.state.CEventShow && (
                                        <>
                                          <div
                                            className="col-sm-12 mt-2"
                                            id="givbeeText"
                                          >
                                            <div className="row align-items-end">
                                              <p
                                                className="mb-0"
                                                style={{ paddingRight: "26px" }}
                                              >
                                                GivBee's integration with
                                                Cvent's registration platform
                                                requires webhook activation
                                                within your Cvent account.<br></br>
                                                Setup instructions are available here:
                                                <span
                                                  className="anchortag ms-1"
                                                  onClick={(e) => {
                                                    e.preventDefault();

                                                    const width = 900;
                                                    const height = 700;

                                                    // Calculate center
                                                    const left =
                                                      window.screenX +
                                                      (window.outerWidth -
                                                        width) /
                                                      2;
                                                    const top =
                                                      window.screenY +
                                                      (window.outerHeight -
                                                        height) /
                                                      2;

                                                    window.open(
                                                      pdfFile,
                                                      "pdfPopup",
                                                      `width=${width},height=${height},left=${left},top=${top},scrollbars=yes,resizable=yes`
                                                    );
                                                  }}
                                                >
                                                  GivBee-Cvent Setup.PDF
                                                </span>
                                              </p>
                                            </div>
                                          </div>
                                        </>
                                      )}
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div
                              className="col-12 d-flex justify-content-between"
                              style={{ marginTop: "2em" }}
                            >
                              <button
                                className="btn btn-label-secondary btn-prev"
                                style={{
                                  display: "flex",
                                  background: "gray",
                                  color: "#fff",
                                }}
                                onClick={
                                  (this.state.businessType?.businessDomainName === "EventText" && this.state.selectedPlan?.planType?.type === "Onetime") ?
                                    this.handlePreviousEventDetailsPage.bind(
                                      this
                                    ) : this.handlePreviousUseCaseDetailsPage.bind(
                                      this
                                    )
                                }
                              >
                                <i className="bx bx-chevron-left bx-sm ms-sm-n2" />
                                <span className="align-middle d-sm-inline-block d-none">
                                  Back
                                </span>
                              </button>

                              <button
                                type="submit"
                                className="btn btn-primary btn-next"
                                style={{ display: "flex" }}
                              >
                                <span className="align-middle d-sm-inline-block d-none me-sm-1 me-0">
                                  Next
                                </span>
                                <i className="bx bx-chevron-right bx-sm me-sm-n2"></i>
                              </button>
                            </div>
                          </div>
                        </ValidatorForm>
                        {this.scheduleCall()}
                        {this.helpContentsDialogBox()}{" "}
                      </>
                    )}
                    {/* Billing Links */}
                    {this.state.activeBillingLinksStep === true && (
                      <>
                        <div
                          id="multiStepsForm"
                          className={
                            this.state.activeBillingLinksStep === true
                              ? "content active dstepper-block fv-plugins-bootstrap5 fv-plugins-framework"
                              : '"content'
                          }
                        >
                          <div className="card mb-3" id="giveBeeCard">
                            <div className="row">
                              <div
                                className="col-12 d-flex justify-content-between"
                              // style={{ marginTop: "2em" }}
                              >
                                {" "}
                                <span
                                  style={{
                                    color: "#162c50",
                                    margin: "0em",
                                  }}
                                >
                                  <Checkbox
                                    style={{ color: "black" }}
                                    id="smsConsentCheckbox"
                                    checked={
                                      this.state.acceptTermsConditionCheckbox
                                    }
                                    onChange={
                                      this
                                        .handleClickAcceptTermsConditionCheckBox
                                    }
                                  />
                                </span>
                                <label
                                  className="mb-0 ps-1"
                                  style={{ color: "#353538" }}
                                  htmlFor="smsConsentCheckbox"
                                >
                                  {" "}
                                  I hereby agree to terms and authorize GivBee,
                                  LLC to charge the credit card account
                                  identified above for all amounts due on my
                                  Givbee account. This authorization is to
                                  remain in full effect until my account has
                                  been deactivated or deleted from Givbee.com
                                  and for as long as charges remain outstanding
                                  on my account. I know that I can update/change
                                  this credit card information at any time and
                                  that if a valid payment option is not on file,
                                  my GivBee account may be deactivated
                                  (unusable) until one is provided.
                                </label>
                              </div>
                            </div>
                          </div>
                          <div className="card " id="giveBeeCard">
                            <div class="row  justify-content-around">
                              <div className="col-md-6 align-self-center">
                                <div className="row d-flex align-item-stretch justify-content-center">
                                  <div className="col-md-6">
                                    <div
                                      className="row d-flex"
                                      style={{
                                        height: "100%",
                                      }}
                                    >
                                      <div className="col-md-12">
                                        <div
                                          className="box"
                                          data-aos="zoom-in"
                                          data-aos-delay={100}
                                          style={{
                                            padding: "0em",
                                            position: "relative",
                                            height: "100%",
                                          }}
                                          id="regPlanBox"
                                        >
                                          <div
                                            class="regplan-inner plan_card plan_card_bottom"
                                            style={{
                                              height: "100%",
                                            }}
                                          >
                                            <div
                                              class="entry-title plan_card"
                                              style={{
                                                background:
                                                  this.state.selectedPlan
                                                    ?.colorSecondary,
                                              }}
                                            >
                                              <h3
                                                class="plan_card"
                                                style={{
                                                  padding: "7px",
                                                  color: "#fff",
                                                  background:
                                                    this.state.selectedPlan
                                                      ?.colorPrimary,
                                                }}
                                              >
                                                {this.state.selectedPlan?.name}
                                              </h3>
                                              <div
                                                class="price"
                                                style={{
                                                  background:
                                                    this.state.selectedPlan
                                                      ?.colorPrimary,
                                                }}
                                              >
                                                <span
                                                  style={{
                                                    left: "20px",
                                                  }}
                                                >
                                                  {`$${this.state.selectedPlan?.price}`}
                                                </span>
                                              </div>
                                            </div>
                                            <div class="entry-content mb-4">
                                              <ul>
                                                {this.state.selectedPlan?.planItems?.map(
                                                  (planItem, index) => (
                                                    <li
                                                      style={{
                                                        padding: "0.2em",
                                                        fontWeight:
                                                          planItem?.isFontBold &&
                                                          "600",
                                                        fontStyle:
                                                          planItem?.isFontItalic &&
                                                          "italic",
                                                        fontSize:
                                                          planItem?.isFontSmall &&
                                                          "12px",
                                                      }}
                                                    >
                                                      {planItem.name}
                                                    </li>
                                                  )
                                                )}
                                              </ul>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div className="col-md-6">
                                <Elements stripe={stripePromise}>
                                  <ElementsConsumer>
                                    {({ stripe, elements }) => (
                                      <RegCreditCardForm
                                        stripe={stripe}
                                        elements={elements}
                                        // key={
                                        //   this.state
                                        //     .acceptTermsConditionCheckbox
                                        // }
                                        selectedPlan={this.state.selectedPlan}
                                        registration={this.state.registration}
                                        acceptTermsConditionCheckbox={
                                          this.state
                                            .acceptTermsConditionCheckbox
                                        }
                                        // isPerEvent={
                                        //   this.state.businessUseCase?.name ===
                                        //     "Text-based fundraising and communication at a single event"
                                        //     ? true
                                        //     : false
                                        // }
                                        isPerEvent={false}
                                      />
                                    )}
                                  </ElementsConsumer>
                                </Elements>
                              </div>
                            </div>
                          </div>
                        </div>
                      </>
                    )}
                  </div>
                </div >
              </div >
            </div >
          </div >
        </div >
        <Footer />
      </>
    );
  }
}

export default withRouter(Registration);
